//routes.js
import * as React from "react";
export const routes = [
  /* -------------------------------------------------------------------------- */
  /*                           Dashboard Routes Starts                          */
  /* -------------------------------------------------------------------------- */
  {
    path: "/",
    Component: React.lazy(() => import("../../Pages/Dashboard/UserDashboard")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/userDashboard",
    Component: React.lazy(() => import("../../Pages/Dashboard/UserDashboard")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/crm-dashboard",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/UserDashboard/crmDashboard")
    ),
    exact: true,
    isNavbar: true,
    allowedDepartment: ["6"]
  },
  {
    path: "/dashboard/sales",
    Component: React.lazy(() => import("../../Pages/Dashboard/Sales")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/crm",
    Component: React.lazy(() => import("../../Pages/Dashboard/Crm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/accounts",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/AccountsDashboard/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/marketing",
    Component: React.lazy(() => import("../../Pages/Dashboard/Marketing")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/procurment",
    Component: React.lazy(() => import("../../Pages/Dashboard/Procurment")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/civil",
    Component: React.lazy(() => import("../../Pages/Dashboard/Civil")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/civil-progress",
    Component: React.lazy(() => import("../../Pages/Dashboard/CivilProgress")),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/dashboard/civil-process-progress',
  // 	Component: React.lazy(() => import('../../Pages/Dashboard/CivilProcessProgress')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  {
    path: "/dashboard/pre-sales",
    Component: React.lazy(() => import("../../Pages/Dashboard/PreSales")),
    exact: true,
    isNavbar: true
  },
  /* -------------------------------------------------------------------------- */
  /*                            Dashboard Routes Ends                           */
  /* -------------------------------------------------------------------------- */
  {
    path: "/login",
    Component: React.lazy(() => import("../../Pages/Login")),
    exact: true,
    isNavbar: false
  },

  /* -------------------------------------------------------------------------- */
  /*                            Reports Routes Starts                            */
  /* -------------------------------------------------------------------------- */
  {
    path: "/profitable-report",
    Component: React.lazy(() => import("../../Pages/Reports")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/nextHearing/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/CourtCase")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/courtCase/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/CourtReminder")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison-reports/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/Liaison")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison-fallowups-reports/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/Task")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison_kns_report/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/LiaisonKnsReport")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison_shc_report/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/liaisonShcReport")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison_all_report/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/LiaisonAllReport")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/liaison_own_report/:reportDate/:processOwnerID",
    Component: React.lazy(() => import("../../Pages/Reports/LiaisonOwnReport")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/profitable",
    Component: React.lazy(() => import("../../Pages/Reports/Profitable")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/task-wise-quantity/:reportDate",
    Component: React.lazy(() => import("../../Pages/Reports/TaskWiseQuantity")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/grn-on-time-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/GRNOnTimeKPIReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/vendor-lead-time-report",
    Component: React.lazy(() => import("../../Pages/Reports/VendorLeadTime")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/purchase-invoice-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/PurchaseInvoiceKPI")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/purchase-invoice-kpi-detail-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/PurchaseInvoiceKPIDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/material-quality-rejection-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/MaterialQualityRejection")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/material-quality-rejection-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/MaterialQualityRejectionKPI")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/indent-po-report",
    Component: React.lazy(() => import("../../Pages/Reports/IndentPO")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/on-time-delivery-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/OnTimeDeliveryKPI")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/on-time-delivery-detail-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/OnTimeDeliveryKPIDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/procurement-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProcurementKPIReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/Liaison-Process-Plan-Kpi",
    Component: React.lazy(
      () => import("../../Pages/Reports/LiaisonProcessPlanKpi")
    ),
    exact: true,
    isNavbar: true
  },

  //Team Report
  {
    path: "/report/sales-team-review-report",
    Component: React.lazy(() => import("../../Pages/Reports/SalesTeamReview")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/SalesReviewDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/actual-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualFollowUp")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/planned-site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/PlannedSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/planned-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/PlannedCall")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/actual-site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/prospective-client",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/TotalCancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/cancellation-previous",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/CancellationPrevious")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/booking",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/TotalBooking.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/gross-sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualGrossSales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/hot-prospective-client",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/HotProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/planned-cp-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/PlannedCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/actual-cp-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/planned-client-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/PlannedClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/actual-client-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },

  //Review Report
  {
    path: "/report/sales-review-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/actual-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualFollowUp")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/planned-site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/PlannedSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/planned-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/PlannedCall")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/actual-site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/prospective-client",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/TotalCancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/cancellation-previous",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/CancellationPrevious")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/booking",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/TotalBooking.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/gross-sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualGrossSales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/hot-prospective-client",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/HotProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/planned-cp-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/PlannedCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/actual-cp-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/planned-client-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/PlannedClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/actual-client-meeting",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/enquiry-follow-up",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/EnquiryFollowUp")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report",
    Component: React.lazy(() => import("../../Pages/Reports/KPIsalesReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_pre_sales_report",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIpreSalesReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_pre_sales_report/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIpreSalesReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_pre_sales_crm_report",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPISalesCrmReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi-pre-sales-summary",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIPreSalesSummary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi-pre-sales-summary/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIPreSalesSummary/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/KPI_Sales_Summary_Report",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPISalesSummaryReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/KPI_Sales_Summary_Report/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPISalesSummaryReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_telecalling_report",
    Component: React.lazy(() => import("../../Pages/Reports/KPITeleCalling")),
    exact: true,
    isNavbar: true
  },

  //   Nikhil 20 july

  {
    path: "/report/kpi_pre_sales_report/totalLeadAssigned",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIpreSalesReport/totalLeadAssinged")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_pre_sales_report/qualifiedLead",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIpreSalesReport/qualifiedLead")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_pre_sales_report/totalSiteVisit",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIpreSalesReport/totalSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },

  // Nithish 20 july

  {
    path: "/report/kpi_sales_report/total_site_visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/TotalSiteVisit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report/total_booking",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/TotalBooking.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report/total_cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/TotalCancellation.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report/total_booking",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/TotalBooking.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/kpi_sales_report/total_cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/KPIsalesReport/TotalCancellation.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/view",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/LeadCampaignReport/LeadCampaignReportDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/total-lead",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport/TotalLead")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/qualified-lead",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport/TotalQualifiedLead")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport/TotalSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/booking",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport/TotalBooking")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/lead-campaign-report/total-cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadCampaignReport/TotalCancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/sales-report",
    Component: React.lazy(() => import("../../Pages/Reports/SalesReport")),
    exact: true,
    isNavbar: true
  },

  /* -------------------------------------------------------------------------- */
  /*                             Reports Routes Ends                            */
  /* -------------------------------------------------------------------------- */

  {
    path: "/liaison",
    Component: React.lazy(() => import("../../Pages/Liaison")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/progress",
    Component: React.lazy(() => import("../../Pages/Civil/ProjectProgress")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/budget",
    Component: React.lazy(() => import("../../Pages/Civil/ProjectBudget")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-nmr-planning",
    Component: React.lazy(() => import("../../Pages/Civil/ManPowerPlanning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-nmr-planning-details",
    Component: React.lazy(
      () => import("../../Pages/Civil/ManPowerDetailPlanning")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-machine-planning",
    Component: React.lazy(() => import("../../Pages/Civil/MachinePlanning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-machine-planning-details",
    Component: React.lazy(
      () => import("../../Pages/Civil/MachinDetailPlanning")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-type-planning",
    Component: React.lazy(() => import("../../Pages/Civil/MachinePlanning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/resource-planning",
    Component: React.lazy(() => import("../../Pages/Civil/ResourcePlanning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/proposed",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProposedProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/up-coming",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/UpcomingProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/up-coming/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/UpcomingProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/up-coming/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/UpcomingProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/on-going",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/OngoingProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/on-going/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/OngoingProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/on-going/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/OngoingProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/completed",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CompletedProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/completed/ReviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/CompletedProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/completed/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CompletedProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/dropped",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DroppedProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/dropped/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DroppedProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/dropped/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DroppedProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/droppedPaymentPendingProject",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/DroppedPaymentPendingProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/droppedPaymentPendingProject/ReviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/DroppedPaymentPendingProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/droppedPaymentPendingProject/editForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/DroppedPaymentPendingProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/proposed/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProposedProject/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/flow",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFlow")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/inspection",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectInspection")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/plan/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/task-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectTaskPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/task-plan/supplementary-deeds",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectTaskPlan/SupplementaryDeeds")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/task-plan/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectTaskPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/approval-pending",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectTaskApprovalPending")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project/ProjectReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/project/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project/project-split",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project/SplitProjectForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project/project-merge",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Project/ProjectMerger")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectSurveyNo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file/ProjectSurveyNoForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectSurveyNo/ProjectSurveyNoForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectSurveyNo/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file/Review",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectSurveyNo/Review")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/liason-process-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonProcessPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonProcessPlan/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonProcessPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan-application/applicationSplitModal",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonProcessPlanApplication/ApplicationSplitModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan/StartDateEditModal",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonProcessPlan/StartDateEditModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan-application",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonProcessPlanApplication")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-process-plan-application/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonProcessPlanApplication/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-task-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonTaskPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-task-plan/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonTaskPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-task-plan/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonTaskPlan/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiasonDocumentation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentation/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation/documentCheckList",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentation/DocumentCheckListForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation/ownerAssign",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentation/OwnerAssignForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation-approval",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentationApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation-approval/approval",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentationApproval/ApprovalModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-survey/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectSurveyNo/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/task-plan/approvals",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectTaskPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/survey-no-pending",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SurveyNumberTaskPending")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/survey-no/approvals",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SurveyNumberTaskPending/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-Process-Applicability",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessApplicability/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/task-plan-document",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/TaskPlanDocument/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-profitable",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Profitable")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/notifications",
    Component: React.lazy(() => import("../../Pages/Notifications")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/milestone",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/MileStone")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/authorization",
    Component: React.lazy(() => import("../../Pages/Authorization")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/authorization/new",
    Component: React.lazy(() => import("../../Pages/Authorization/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandOwner")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandOwner/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandOwner/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner/details",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandOwner/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner/newAccounts",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandOwner/landOwnerAccountModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-owner/accountEdit",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandOwner/landOwnerAccountEditModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file-acquisition-info",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFIleAcquisitionInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file-acquisition-info/new",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectFIleAcquisitionInfo/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file-acquisition-info/approvals",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectFIleAcquisitionInfo/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file-acquisition-info/editForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectFIleAcquisitionInfo/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandBroker")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandBroker/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker/details",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandBroker/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker/accountEdit",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandBroker/landBrokerAccountEditModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker/newAccounts",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandBroker/landBrokerAccountModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-broker/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandBroker/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/FeasibilityReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/FeasibilityReport/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/FeasibilityReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report/approval",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/FeasibilityReport/Approval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report/printPdf",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/FeasibilityReport/printPdf")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report-general",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/FeasibilityReportGeneral")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report-general/new",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/FeasibilityReportGeneral/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/feasibility-report-general/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/FeasibilityReportGeneral/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-fund",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFund")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-fund/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFund/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-fund/Review",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFund/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-broker",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectBroker")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-broker/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectBroker/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandPayment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandPayment/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment/brokerPayment",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandPayment/brokerPaymentForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandPayment/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment/requestAmountForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandPayment/requestAmountForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-payment/governmentFeeForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandPayment/governmentFeeForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-payment/advancePaymentForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandPayment/advancePaymentForm")
    ),
    exact: true,
    isNavbar: true
  },
  //BD Land payment
  {
    path: "/business-development/bd-land-payment",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BDLandPayment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-land-payment/form",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BDLandPayment/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-land-payment/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BDLandPayment/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-land-payment/approve",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/BDLandPayment/PaymentRequestApprove")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-land-payment/send-for-approval",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/BDLandPayment/PaymentRequestSendForApprove.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-land-payment/settle",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BDLandPayment/settle.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/basic-document",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BasicDocument")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/basic-document/form",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BasicDocument/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/basic-document/basicDocumentForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/BasicDocument/basicDocumentForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/account-payable",
    Component: React.lazy(() => import("../../Pages/Accounts/AccountPayable")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/account-payable/new",
    Component: React.lazy(
      () => import("../../Pages/Accounts/AccountPayable/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/account-payable/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/AccountPayable/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/paid-account",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaidAccount/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/paid-account/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaidAccount/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-progress",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/CivilProject/ProjectProgress")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-progress/projectProgressDetail",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/CivilProject/projectProgressDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-progress/projectProgressTaskDetail",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/CivilProject/taskProgressDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/proposed/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProposedProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/proposed/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProposedProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-company-map",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectCompanyMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-company-map/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectCompanyMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-company-map/approvals",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectCompanyMap/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonReport")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/test/test",
  //   Component: React.lazy(() => import("../../Pages/Test/Test")),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/test/test2",
  //   Component: React.lazy(() => import("../../Pages/Test/Test2")),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/test/testPrint",
  //   Component: React.lazy(() => import("../../Pages/TestPDFPrint")),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/profile",
    Component: React.lazy(() => import("../../Pages/Profile/UserProfile")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/profile/editForm",
    Component: React.lazy(
      () => import("../../Pages/Profile/UserProfile/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/birthdayWish",
    Component: React.lazy(() => import("../../Pages/Greetings/Birthday")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/workAnniversary",
    Component: React.lazy(
      () => import("../../Pages/Greetings/WorkAnniversary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/consolidated-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ConsolidatedReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/consolidated-report/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ConsolidatedReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/documentation-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DocumentationReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-task",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-task/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-task/Review",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfTask/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-summary",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfSummary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-query",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfQuery")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-query/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfQuery/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-query/Review",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfQuery/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-dispute",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandDispute")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-dispute/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandDispute/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-dispute/Review",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandDispute/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-dispute/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandDispute/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/court-case/",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CourtCase")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/court-case/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CourtCase/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/court-case/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CourtCase/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/court-case/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CourtCase/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-investment",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectInvestment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-query",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectQuery")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-query/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectQuery/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-summary",
    Component: React.lazy(() => import("../../Pages/Dashboard/ProjectSummary")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/document-rework-report",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/DocumentReworkReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-task-report",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/ProjectTaskReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/training",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Training")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/training/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Training/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-dispute/landDisputeForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandDispute/landDisputeForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/court-case/courtCaseForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/CourtCase/courtCaseForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/apf-task/apfTaskForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ApfTask/apfTaskForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/projectNamingForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProposedProject/projectNamingForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/trainingContent",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/TraningContent")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/business-development/liaison-payment',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/new',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/form')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/view',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/ReviewForm')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/addPaymentRequest',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/addPaymentRequest')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/approval',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/Approval')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/issue',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/Issue')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/settlementRequest',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/settlementRequest')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/settlementApproval',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/settlementApproval')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/settlementSettle',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/settlementSettle')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/liaison-payment/detail',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LiaisonPayment/Detail')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  {
    path: "/business-development/loan",
    Component: React.lazy(() => import("../../Pages/BusinessDevelopment/Loan")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/loan/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Loan/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/investment",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/Investment")
    ),
    exact: true,
    isNavbar: true
  },
  // Master
  {
    path: "/business-development/liaison-process-list",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonProcessMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-list/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonProcessMaster/Form")
    ),
    exact: true,
    isNavbar: true
  },
  // Master End
  {
    path: "/business-development/liaison-process-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonProcessPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/StartDateEditModal",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/StartDateEditModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/SurveyAddModel",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/SurveyAddModel")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/applicationSplitModal",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/ApplicationSplitModal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-task-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonTaskPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-task-plan/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonTaskPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-task-plan/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonTaskPlan/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan-approval",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonProcessPlanApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan-approval/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlanApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan-approval/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlanApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison/legal-task",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LegalTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison/legal-task/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LegalTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison/legal-task/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LegalTask/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison/legal-task/legalTaskForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LegalTask/legalTaskForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison/legal-task/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LegalTask/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/newsletter",
    Component: React.lazy(() => import("../../Pages/Admin/Newsletter")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/newsletter/new",
    Component: React.lazy(() => import("../../Pages/Admin/Newsletter/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/ProjectTaskOwnerUpdate",
    Component: React.lazy(
      () => import("../../Pages/Admin/Newsletter/ProjectTaskOwnerUpdate")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/ProjectSurveyMapping",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/ProjectSurveyMapping")
    ),
    exact: true,
    isNavbar: true
  },
  // ---dashboard new --
  {
    path: "/dashboard/bd",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/BusinessDevelopment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/liaison",
    Component: React.lazy(() => import("../../Pages/Dashboard/Liaison")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/documentation",
    Component: React.lazy(() => import("../../Pages/Dashboard/Documentation")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/ProjectFileDeed",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFileDeeds")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/ProjectFileDeed/ReviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectFileDeeds/ProjectFileDeedReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/ProjectFileDeed/Form",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFileDeeds/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/bd-consolidated-report",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ConsolidatedReport/BDConsolidatedReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/pendingTask",
    Component: React.lazy(() => import("../../Pages/Dashboard/PendingTask")),
    exact: true,
    isNavbar: true
  },

  // {
  // 	path: '/master/bdMaster/ProjectTaskDependency',
  // 	Component: React.lazy(() => import('../../Pages/Master/BDMaster/ProjectTaskDependency')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/master/bdMaster/ProjectTaskDependency/new',
  // 	Component: React.lazy(() => import('../../Pages/Master/BDMaster/ProjectTaskDependency/form')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/master/bdMaster/ProjectTaskDependency/edit',
  // 	Component: React.lazy(() => import('../../Pages/Master/BDMaster/ProjectTaskDependency/Reviewform')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // _______________________Sadanand______________
  {
    path: "/business-development/toBeAcquiredFile",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ToBeAcquiredFile")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/toBeAcquiredFile/ReviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ToBeAcquiredFile/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/toBeAcquiredFile/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ToBeAcquiredFile/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-process-plan/bulkOwnerAssign",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/LiaisonProcessOwnerAssignForm")
    ),
    exact: true,
    isNavbar: true
  },
  // unused
  // {
  // 	path: '/business-development/loan-process',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LoanProcess')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/loan-process/new',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LoanProcess/Form')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/loan-process/view',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LoanProcess/ReviewForm')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/loan-task-plan',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LoanTaskPlan')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  // {
  // 	path: '/business-development/loan-task-plan/view',
  // 	Component: React.lazy(() => import('../../Pages/BusinessDevelopment/LoanTaskPlan/ReviewForm')),
  // 	exact: true,
  // 	isNavbar : true
  // },
  {
    path: "/business-development/liaison-process-plan/updateBulk",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlan/LiaisonProcessUpdateBulkForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/delayed-process",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DelayedProcess")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/delayed-process/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DelayedProcess/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //   BD Master
  {
    path: "/bd-masters/BdIssueType",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdIssueType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/BdIssueType/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdIssueType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/BdIssueType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdIssueType/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessCategory/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessCategory/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessCategory/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/ProjectTask",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/ProjectTask/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTask/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonProcess/Edit-Review-form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTask/EditReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskCategory/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskCategory/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskCategory/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskDependency",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskDependency")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskDependency/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskDependency/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskDependency/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/ProjectTaskDependency/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/PlanningAuthority",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PlanningAuthority")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/PlanningAuthority/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PlanningAuthority/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/PlanningAuthority/Reviewform",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PlanningAuthority/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonTaskCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTaskCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonTaskCategory/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTaskCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonTaskCategory/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTaskCategory/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonTask",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonTask/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonTask/Review-form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonTask/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/delayed-liaison-task-plan",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DelayedLiaisonTaskPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/delayed-liaison-task-plan/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/DelayedLiaisonTaskPlan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/project-file/split-sy-no",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProjectSurveyNo/SurveySplitModal")
    ),
    exact: true,
    isNavbar: true
  },
  // HR  module
  // {
  // 	path: "/HR/PaymentRequestedBy",
  // 	Component: React.lazy(() =>
  // 	  import("../../Pages/HR/PettyCash/PaymentRequestedBy")
  // 	),
  // 	exact: true,
  // 	isNavbar: true,
  //   },
  //   {
  // 	path: "/HR/PaymentRequestedBy/form",
  // 	Component: React.lazy(() => import("../../Pages/HR/PettyCash/form")),
  // 	exact: true,
  // 	isNavbar: true,
  //   },
  //   {
  // 	path: "/HR/Paymentissue",
  // 	Component: React.lazy(() =>
  // 	  import("../../Pages/HR/PettyCash/PaymentIssueby")
  // 	),
  // 	exact: true,
  // 	isNavbar: true,
  //   },
  //   {
  // 	path: "/HR/SettlementApprovalsBy",
  // 	Component: React.lazy(() =>
  // 	  import("../../Pages/HR/PettyCash/SettlementApprovalsBy")
  // 	),
  // 	exact: true,
  // 	isNavbar: true,
  //   },
  {
    path: "/HR/VehicleFuelRequest",
    Component: React.lazy(() => import("../../Pages/HR/VehicleFuelRequest")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleFuelRequest/new",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleFuelRequest/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleFuelRequest/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleFuelRequest/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleFuelRequest/fuel-bill",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleFuelRequest/VehicleFuelBillPay")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleService",
    Component: React.lazy(() => import("../../Pages/HR/VehicleService")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleService/new",
    Component: React.lazy(() => import("../../Pages/HR/VehicleService/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleService/update",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleService/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleService/print",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleService/VechialServicePrint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/VehicleService/edit",
    Component: React.lazy(() => import("../../Pages/HR/VehicleService/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-report",
    Component: React.lazy(() => import("../../Pages/HR/AttendanceReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-report/new",
    Component: React.lazy(() => import("../../Pages/HR/AttendanceReport/form")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/HR/DailyAttendanceReport",
    Component: React.lazy(
      () => import("../../Pages/HR/EmployeeAttendanceDetails")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/HR/LeaveApplication",
  //   Component: React.lazy(() => import("../../Pages/HR/LeaveApplication")),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/HR/LeaveApplication/new",
  //   Component: React.lazy(() => import("../../Pages/HR/LeaveApplication/form")),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/hr/leave-application",
    Component: React.lazy(() => import("../../Pages/HR/LeaveApplication")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/leave-application/new",
    Component: React.lazy(() => import("../../Pages/HR/LeaveApplication/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/leave-application/review-form",
    Component: React.lazy(
      () => import("../../Pages/HR/LeaveApplication/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/AddAttendance",
    Component: React.lazy(() => import("../../Pages/HR/ImportAttendance")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/AttendanceExport",
    Component: React.lazy(() => import("../../Pages/HR/ExportAttendance")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/EmployeeLoginList",
    Component: React.lazy(
      () => import("../../Pages/HR/EmployeeLocationApprovals")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/task",
    Component: React.lazy(() => import("../../Pages/HR/Task")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/task/addtask",
    Component: React.lazy(() => import("../../Pages/HR/Task/addtask")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/task/view",
    Component: React.lazy(() => import("../../Pages/HR/Task/ReviewForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/task/view-mobile",
    Component: React.lazy(
      () => import("../../Pages/HR/Task/ReviewFormMobile.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/task/edit",
    Component: React.lazy(() => import("../../Pages/HR/Task/editForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/LeaveSummary",
    Component: React.lazy(() => import("../../Pages/HR/EmployeeLeaveSummary")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/CompOffLeaveSummary",
    Component: React.lazy(
      () => import("../../Pages/HR/EmployeeCompOffLeaveSummary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/plan-approval-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/PlanApprovalReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/LiaisonProcess",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcess")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/LiaisonProcess/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcess/LiaisonProcessForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/LiaisonProcess/Edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcess/EditReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan",
    Component: React.lazy(() => import("../../Pages/Civil/CivilProjectPlan")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/bd-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BD_KPI_REPORT")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/new",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/team-planner",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/TeamPlanner")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/locations",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/Locations")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan-wbs",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkBreakDownStructure")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/proposed/project-merger",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/ProposedProject/ProjectMerger")
    ),
    exact: true,
    isNavbar: true
  },
  //Activity not in use
  {
    path: "/civil/civil-project-task-plan-activity",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectTaskPlanActivity")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-plan-activity/new",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectTaskPlanActivity/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-plan-activity/quantityPlanning",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilProjectTaskPlanActivity/QuantityPlanning")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-plan-activity/materialPlanning",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilProjectTaskPlanActivity/MaterialPlanning")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-plan-activity/resourceIdentification",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilProjectTaskPlanActivity/ResourceIdentification")
    ),
    exact: true,
    isNavbar: true
  },
  // Nikhil
  {
    path: "/bd-masters/PaymentMilestone",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PaymentMilestone/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/PaymentMilestone/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PaymentMilestone/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/PaymentMilestone/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/PaymentMilestone/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan-wbs/new",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkBreakDownStructure/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskRejectionReason",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskRejectionReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskRejectionReason/new",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/ProjectTaskRejectionReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskRejectionReason/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/ProjectTaskRejectionReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/AgreementType",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/AgreementType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/AgreementType/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/AgreementType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/AgreementType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/AgreementType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseType",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseType/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtEstablishment",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtEstablishment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtEstablishment/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtEstablishment/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtEstablishment/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtEstablishment/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseStatus",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseStatus")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseStatus/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/CourtCaseStatus/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/CourtCaseStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFees",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFee")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFees/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFee/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFees/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFee/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFeesRate",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFeesRate")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFeesRate/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFeesRate/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/RegistrationFeesRate/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/RegistrationFeesRate/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Liaison_Process_Exception",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessException")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Liaison_Process_Exception/Form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessException/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Liaison_Process_Exception/Edit_Form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessException/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonProcessDependency",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessDependency")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonProcessDependency/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LiaisonProcessDependency/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LiaisonProcessDependency/Edit_form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessDependency/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/apf-panel",
    Component: React.lazy(() => import("../../Pages/Master/BDMaster/ApfPanel")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/apf-panel/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ApfPanel/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/apf-panel/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ApfPanel/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/apf-panel/review",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ApfPanel/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/apfTask",
    Component: React.lazy(() => import("../../Pages/Master/BDMaster/ApfTask")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/apfTask/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ApfTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/apfTask/form-edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ApfTask/Editform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BD",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/BdMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Bank",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/BankMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Liaison",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/LiaisonMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Legal",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/LegalMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/General",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/GeneralMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Civil-Master/Civil",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/CivilMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/project_document_type",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDocumentType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/project_document_type/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDocumentType/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/project_document_type/edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDocumentType/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/HR",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/HRMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Finance",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/FinanceMaster")
    ),
    exact: true,
    isNavbar: true
  },
  //
  {
    path: "/BD-Master/TaskDelayReason",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/TaskDelayReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/TaskDelayReason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/TaskDelayReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/TaskDelayReason/Edit_from",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/TaskDelayReason/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BankMaster",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BankMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BankMaster/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BankMaster/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BankMaster/form_edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BankMaster/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LoanTask",
    Component: React.lazy(() => import("../../Pages/Master/BDMaster/LoanTask")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LoanTask/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/LoanTask/edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanTask/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil-master/wbs",
    Component: React.lazy(() => import("../../Pages/Master/CivilMaster/WBS")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity",
    Component: React.lazy(() => import("../../Pages/Civil/Activity")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskTransaction",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskTransaction")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskTransaction/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskTransaction/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectTaskTransaction/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectTaskTransaction/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectDropReason",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDropReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectDropReason/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDropReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectDropReason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectDropReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanPanel",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanPanel")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanPanel/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanPanel/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanPanel/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanPanel/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcess",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcess")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcess/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcess/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcess/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcess/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdTaskApproval",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdTaskApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdTaskApproval/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdTaskApproval/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdTaskApproval/Edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/BdTaskApproval/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/project-charter-detail",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/ProjectCharterPrint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/wbs",
    Component: React.lazy(() => import("../../Pages/Civil/WBS")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/wbs/new",
    Component: React.lazy(() => import("../../Pages/Civil/WBS/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/SubRegistrarOfficeList",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarOffice")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/SubRegistrarOfficeList/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarOffice/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/SubRegistrarOfficeList/Edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarOffice/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdSubRegistrarMapping",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarMapping")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdSubRegistrarMapping/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarMapping/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/BdSubRegistrarMapping/Edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/SubRegistrarMapping/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/new",
    Component: React.lazy(
      () => import("../../Pages/Civil/Activity/ActivityAddForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessApplicabilityReason",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessApplicabilityReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessApplicabilityReason/new",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessApplicabilityReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LiaisonProcessApplicabilityReason/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/BDMaster/LiaisonProcessApplicabilityReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  /* -------------------------------------------------------------------------- */
  /*                          //Sadanand Gadwal (Civil)                          */
  /* -------------------------------------------------------------------------- */
  {
    path: "/civil/object-output-list",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ObjectOutputList")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/object-output-list/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ObjectOutputList/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/object-output-list/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ObjectOutputList/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-process",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectProcess")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-process/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectProcess/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-process/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/CivilProjectProcess/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectTask/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-role",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectRole")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-role/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectRole/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-role/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectRole/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-uom",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectTaskUOM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-uom/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilProjectTaskUOM/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-uom/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/CivilProjectTaskUOM/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-resource-type",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilResourceType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-resource-type/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilResourceType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-resource-type/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/CivilResourceType/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/projectResource",
    Component: React.lazy(() => import("../../Pages/Civil/CivilResource")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/projectResource/new",
    Component: React.lazy(() => import("../../Pages/Civil/CivilResource/form")),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/civil/projectResource/new-material',
  // 	Component: React.lazy(() => import('../../Pages/Civil/CivilResource/materialForm')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  {
    path: "/civil/projectResource/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilResource/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/Accounts",
    Component: React.lazy(
      () => import("../../Pages/Master/MasterList/AccountMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeeting/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting/view",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeeting/Review")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting/edit",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeeting/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/object-output-list/copy",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/ObjectOutputList/Projectcopy")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/projectResource/copy",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilResource/Projectcopy")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/RoleFunctionality",
    Component: React.lazy(() => import("../../Pages/HR/RoleFunctionality")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/RoleFunctionality/new",
    Component: React.lazy(
      () => import("../../Pages/HR/RoleFunctionality/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/RoleFunctionality/edit",
    Component: React.lazy(
      () => import("../../Pages/HR/RoleFunctionality/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/PublicHoliday",
    Component: React.lazy(() => import("../../Pages/HR/PublicHoliday")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/PublicHoliday/new",
    Component: React.lazy(() => import("../../Pages/HR/PublicHoliday/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/PublicHoliday/edit",
    Component: React.lazy(() => import("../../Pages/HR/PublicHoliday/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-plan/project-charter-add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectPlan/ProjectCharterAddForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-task-plan-activity/quantity-planning-form",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilProjectTaskPlanActivity/QuantityPlanningFromTaskPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/doc-edit",
    Component: React.lazy(() => import("../../Pages/HR/docs-edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectZone",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectZone")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectZone/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectZone/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectZone/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectZone/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingParticular",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingParticular")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingParticular/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingParticular/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingParticular/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingParticular/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingStage",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingStage")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingStage/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingStage/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LandLordMeetingStage/Edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LandLordMeetingStage/FormEdit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/outpass",
    Component: React.lazy(() => import("../../Pages/HR/Hroutpass")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/outpass/Form",
    Component: React.lazy(() => import("../../Pages/HR/Hroutpass/Form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/outpass/review-form",
    Component: React.lazy(() => import("../../Pages/HR/Hroutpass/EditForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceApproval",
    Component: React.lazy(() => import("../../Pages/HR/SalaryAdvanceApprove")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceApproval/form",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceApprove/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceIssue",
    Component: React.lazy(() => import("../../Pages/HR/SalaryAdvanceIssue")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceIssue/form",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceIssue/Form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/civil/activity-resource",
    Component: React.lazy(() => import("../../Pages/Civil/ActivityResource")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/MOUDateUpdate",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/MOUDateUpdate")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/civil/activity-resource/new',
  // 	Component: React.lazy(() => import('../../Pages/Civil/ActivityResource/form')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/civil/activity-resource/edit',
  // 	Component: React.lazy(() => import('../../Pages/Civil/ActivityResource/ReviewForm')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  {
    path: "/civil/civil-Task-Budget",
    Component: React.lazy(() => import("../../Pages/Civil/CivilTaskBudget")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Task-Budget/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskBudget/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Task-Budget/detail",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskBudget/CivilTaskBudgetDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-wise-budget",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskWiseBudgetReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-wise-budget/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskWiseBudgetReport/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-wise-budget/update",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskWiseBudgetReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/budget-approval",
    Component: React.lazy(
      () => import("../../Pages/Civil/Activity/BudgetSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/project-schedule",
    Component: React.lazy(
      () => import("../../Pages/Civil/Activity/ProjectScheduleSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/quantity-estimation",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/Activity/QuantityEstimationSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-budget",
    Component: React.lazy(() => import("../../Pages/Civil/CivilProjectBudget")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-wbs-budget",
    Component: React.lazy(() => import("../../Pages/Civil/CivilWbsBudget")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-activity-budget",
    Component: React.lazy(() => import("../../Pages/Civil/CivilTaskBudget")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills",
    Component: React.lazy(() => import("../../Pages/Civil/CivilProjectBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills/print",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectBill/ProjectBillPrint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectBill/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-dependency-exception",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LiaisonDependencyException")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-dependency-exception/add",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonDependencyException/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liaison-dependency-exception/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonDependencyException/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/enquiry-project",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/EnquiryProject")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/enquiry-project/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/EnquiryProject/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/enquiry-project/editForm",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/EnquiryProject/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-schedule",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectSchedule")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeetingReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeetingReport/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandLordMeetingReport/Review")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandLordMeetingReport/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/gantt-trial",
    Component: React.lazy(
      () => import("../../Pages/Civil/GanttSyncfusion/Gantt")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/gantt-chart",
    Component: React.lazy(
      () => import("../../Pages/Civil/GanttSyncfusion/GanttChart")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Designation",
    Component: React.lazy(() => import("../../Pages/HR/Designation")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Designation/new",
    Component: React.lazy(() => import("../../Pages/HR/Designation/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Designation/edit",
    Component: React.lazy(() => import("../../Pages/HR/Designation/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Designation/form-new",
    Component: React.lazy(() => import("../../Pages/HR/Designation/form1")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Department",
    Component: React.lazy(() => import("../../Pages/HR/Department")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Department/new",
    Component: React.lazy(() => import("../../Pages/HR/Department/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Department/edit",
    Component: React.lazy(() => import("../../Pages/HR/Department/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Level",
    Component: React.lazy(() => import("../../Pages/HR/Level")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Level/new",
    Component: React.lazy(() => import("../../Pages/HR/Level/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Level/edit",
    Component: React.lazy(() => import("../../Pages/HR/Level/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/Designation/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/HR/Designation/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandLordMeetingReport/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandLordMeetingReport/Review")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandLordMeetingReport/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/landlord-meeting-report/print",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandLordMeetingReport/LandLordMeetingReportPrint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/ProjectCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/ProjectCategory/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-master/ProjectCategory/edit_form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderWBS",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WorkOrderWBS")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderWBS/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WorkOrderWBS/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderWBS/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WorkOrderWBS/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderActivity",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WorkOrderActivity")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderActivity/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WorkOrderActivity/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderActivity/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/WorkOrderActivity/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityGroup",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityGroup")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityGroup/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityGroup/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityGroup/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityGroup/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityCategory/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityCategory/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityItems",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityItems")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityItems/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityItems/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProfitabilityItems/form-edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProfitabilityItems/Edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/mou-kpi-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/MOU_KPI_REPORT")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-acquisition-kpi-report",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LAND_ACQUISITION_KPI_REPORT")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/ProjectPhase",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPhase")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/ProjectPhase/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPhase/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/BD-Master/ProjectPhase/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPhase/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/po-rejection-report",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/PurchaseOrderRejectionReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/po-cycle-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/PurchaseOrderCycleReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/ProfitabilityReport",
    Component: React.lazy(
      () => import("../../Pages/Civil/ProfitabilityReport")
    ),
    exact: true,
    isNavbar: true
  },
  /* -------------------------------------------------------------------------- */
  /*                                 //Sadanand Gadwal                               */
  /* -------------------------------------------------------------------------- */
  //work Order Amendment
  {
    path: "/civil/civil-work-order",
    Component: React.lazy(() => import("../../Pages/Civil/WorkOrder")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-order/add",
    Component: React.lazy(() => import("../../Pages/Civil/WorkOrder/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-order/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrder/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-order/edit",
    Component: React.lazy(() => import("../../Pages/Civil/WorkOrder/editForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-order/amendment",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrder/AmendmentReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-order/amendment-approval",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrder/AmendmentApprovalReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // nikhil

  {
    path: "/civil/WorkOrderItemCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WOItemCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderItemCategory/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WOItemCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/WorkOrderItemCategory/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/WOItemCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //General Work Order
  {
    path: "/civil/general-work-order",
    Component: React.lazy(() => import("../../Pages/Civil/GeneralWorkOrder")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/general-work-order/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/GeneralWorkOrder/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/general-work-order/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/GeneralWorkOrder/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/general-work-order/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/GeneralWorkOrder/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/general-work-order/amendment",
    Component: React.lazy(
      () => import("../../Pages/Civil/GeneralWorkOrder/AmendmentReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/general-work-order/amendment-approval",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/GeneralWorkOrder/AmendmentApprovalReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualEntry")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual/machine-entry",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualEntry/MachineEntryFormMain")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual/manpower-entry",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualEntry/ManpowerEntryFormMain")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual/contract-entry",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualEntry/ContractEntryFormMain")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/crm-tat",
    Component: React.lazy(() => import("../../Pages/Dashboard/CrmTAT")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/bd-overall-report",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/BdOverallReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-resource-report-non-material",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/CivilResourceReportNonMaterial")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-resource-report-material",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/CivilResourceReportMaterial")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/project-mortgage",
    Component: React.lazy(() => import("../../Pages/Accounts/ProjectMortgage")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-mortgage/new",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectMortgage/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-mortgage/view",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectMortgage/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-machine",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectMachine")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-machine/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectMachine/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-machine/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectMachine/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-machine/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectMachine/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/vendor-machine",
    Component: React.lazy(() => import("../../Pages/Civil/VendorMachine")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/vendor-machine/add",
    Component: React.lazy(() => import("../../Pages/Civil/VendorMachine/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/vendor-machine/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/VendorMachine/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/vendor-machine/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/VendorMachine/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcessStatus",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcessStatus")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcessStatus/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcessStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/LoanProcessStatus/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/LoanProcessStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan",
    Component: React.lazy(() => import("../../Pages/Accounts/ProjectLoan")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan/new",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoan/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan/view",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoan/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan-process",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoanProcess")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan-process/view",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoanProcess/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-loan-process/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectLoanProcess/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan-query",
    Component: React.lazy(() => import("../../Pages/Accounts/LoanQuery")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan-query/add",
    Component: React.lazy(() => import("../../Pages/Accounts/LoanQuery/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan-query/view",
    Component: React.lazy(
      () => import("../../Pages/Accounts/LoanQuery/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/civil/civil-task-actual-machine",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualMachine")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-machine/measurement-update",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualMachine/MeasurementUpdateForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-machine/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualMachine/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-machine/qc-review",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualMachine/QualityCheckReview")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/civil/civil-task-actual-machine/machine-add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualMachine/MachineEntryForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/activity-quality-check-point",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ActivityQualityCheck")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/activity-quality-check-point/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ActivityQualityCheck/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/activity-quality-check-point/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/ActivityQualityCheck/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/actual-reject-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ActualRejectReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/actual-reject-reason/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ActualRejectReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/actual-reject-reason/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/ActualRejectReason/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Vendor Nithish & Sadanand Pan Logic Changes ------- start
  {
    path: "/Procurement/vendor",
    Component: React.lazy(() => import("../../Pages/Accounts/Vendor")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Procurement/vendor/form",
    Component: React.lazy(() => import("../../Pages/Accounts/Vendor/form.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Procurement/vendor/form-edit",
    Component: React.lazy(() => import("../../Pages/Accounts/Vendor/edit")),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/Procurement/vendorDocument',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorDocument')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/Procurement/VendorService',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorService')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/Procurement/VendorContact',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorContact')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/Procurement/VendorAccount',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorAccount')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/Procurement/VendorAddress',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorAddress')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  {
    path: "/Procurement/VendorDetails",
    Component: React.lazy(
      () => import("../../Pages/Accounts/Vendor/VendorDetails")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/Procurement/VendorMsme',
  // 	Component: React.lazy(() => import('../../Pages/Accounts/Vendor/VendorMsme')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // Vendor Nithish ------- end
  {
    path: "/civil/civil-task-actual-manpower",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualManpower")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-manpower/measurement-update",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualManpower/MeasurementUpdateForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-manpower/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualManpower/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-manpower/qc-review",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualManpower/QualityCheckReview")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-manpower/manpower-add",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualManpower/ManpowerEntryForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualContract")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract/measurement-update",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualContract/MeasurementUpdateForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract/qc-review",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualContract/QualityCheckReview")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualContract/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract/contract-add",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualContract/ContractEntryForm")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  // 	path: '/tempSelect',
  // 	Component: React.lazy(() => import('../../Pages/Test/TempSelect')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  // {
  // 	path: '/tempSelect2',
  // 	Component: React.lazy(() => import('../../Pages/Test/TempSelect2')),
  // 	exact: true,
  // 	isNavbar: true
  // },
  {
    path: "/civil/civil-task-actual-machine/generate-bill",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilTaskActualMachine/GenerateBillForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-manpower/generate-bill",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualManpower/GenerateBillFormManpower")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/vendor-change-request",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorChangeRequest")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/vendor-change-request-detail/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorChangeRequest/detail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-task-actual-contract/generate-bill",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilTaskActualContract/GenerateBillFormContract")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/EPA",
    Component: React.lazy(() => import("../../Pages/HR/EPA")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/EPA/add-hor",
    Component: React.lazy(() => import("../../Pages/HR/EPA/form_hor")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/EPA/preivew",
    Component: React.lazy(() => import("../../Pages/HR/EPA/previewForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/EPA/detail",
    Component: React.lazy(() => import("../../Pages/HR/EPA/detailForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestion")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestion/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question/desgination",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/AppraisalQuestion/DesignationList")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question/option-edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestion/optionEdit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question/view",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestion/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question-option",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestionOption")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question-option/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalQuestionOption/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal-question-option/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/AppraisalQuestionOption/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/stock-masters/material-master",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/MaterialMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/stock-masters/material-master/add",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/MaterialMaster/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/Appraisal")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/Appraisal/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/appraisal/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/Appraisal/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/ItemGroup",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ItemGroup")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/ItemGroup/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ItemGroup/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/ItemGroup/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/ItemGroup/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Material",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Material")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Material/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Material/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Material/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Material/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/booking-form",
    Component: React.lazy(() => import("../../Pages/Sales/BookingForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/booking-form/form",
    Component: React.lazy(() => import("../../Pages/Sales/BookingForm/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/booking-form/review",
    Component: React.lazy(() => import("../../Pages/Sales/BookingForm/Review")),
    exact: true,
    isNavbar: true
  },
  //procument master
  {
    path: "/prc-master/ItemGroup",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/ItemGroup")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/ItemGroup/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/ItemGroup/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/ItemGroup/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/ItemGroup/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/StockUOM",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/StockUOM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/StockUOM/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/StockUOM/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/StockUOM/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/StockUOM/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/civil/project-material-estimate",
    Component: React.lazy(
      () => import("../../Pages/Civil/ProjectMaterialEstimate")
    ),
    exact: true,
    isNavbar: true
  },

  //civil/civil-project-activity/approval  not in use
  // {
  //   path: "/civil/civil-project-activity/approval",
  //   Component: React.lazy(
  //     () =>
  //       import("../../Pages/Civil/Activity/ProjectScheduleSendForApprovalUnused.jsx")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/civil/project-material-procurement-schedule",
    Component: React.lazy(
      () => import("../../Pages/Civil/ProjectMaterialProcurementSchedule")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/project-material-procurement-schedule/view",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/ProjectMaterialProcurementSchedule/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/project-material-procurement-schedule/send-indent",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/ProjectMaterialProcurementSchedule/ScheduleSendForIndent")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-item",
    Component: React.lazy(() => import("../../Pages/Procurement/IndentItem")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-item/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/IndentItem/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-item/approval",
    Component: React.lazy(
      () => import("../../Pages/Procurement/IndentItem/IndentSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-item/new",
    Component: React.lazy(
      () => import("../../Pages/Procurement/IndentItem/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/enquiry-profile",
    Component: React.lazy(() => import("../../Pages/CRM/EnquiryProfile/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/enquiry-profile/new",
    Component: React.lazy(() => import("../../Pages/CRM/EnquiryProfile/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/enquiry-profile/view",
    Component: React.lazy(
      () => import("../../Pages/CRM/EnquiryProfile/Review")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/enquiry-profile/edit",
    Component: React.lazy(
      () => import("../../Pages/CRM/EnquiryProfile/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/enquiry-profile/Feedback",
    Component: React.lazy(
      () => import("../../Pages/CRM/EnquiryProfile/feedbackForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalCategory/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalCategory/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalRating",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalRating")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalRating/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalRating/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/AppraisalRating/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AppraisalRating/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/liason-documentation/bulk_document_form",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiasonDocumentation/AddBulkDocuments")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation",
    Component: React.lazy(() => import("../../Pages/Procurement/Quotation")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation/new",
    Component: React.lazy(
      () => import("../../Pages/Procurement/Quotation/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/Quotation/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation/approval",
    Component: React.lazy(
      () => import("../../Pages/Procurement/Quotation/QuotationSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/Question",
    Component: React.lazy(() => import("../../Pages/Master/HRMaster/Question")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/Question/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/Question/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/Question/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/Question/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOptionValue",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOptionValue")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOptionValue/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOptionValue/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOptionValue/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOptionValue/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOption",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOption")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOption/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOption/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/QuestionOption/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/QuestionOption/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrder")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order/request",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrder/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrder/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order/editForm",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrder/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order-amendment/editForm",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrder/poAmendmentEditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/grn-items",
    Component: React.lazy(() => import("../../Pages/Procurement/GRN")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/grn-items/add",
    Component: React.lazy(() => import("../../Pages/Procurement/GRN/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/grn-items/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/GRN/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/grn-items/editForm",
    Component: React.lazy(() => import("../../Pages/Procurement/GRN/editForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/site-visit-feedback",
    Component: React.lazy(() => import("../../Pages/CRM/SiteVisitFeedback")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/site-visit-feedback/view",
    Component: React.lazy(
      () => import("../../Pages/CRM/SiteVisitFeedback/Review")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/LeaveType",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/LeaveType/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/LeaveType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/project-drawing",
    Component: React.lazy(() => import("../../Pages/Civil/CivilDrawing")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/project-drawing/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilDrawing/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd/Document-Repository",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/DocumentRepository")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/dashboard/budget/civil-project",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/CivilBudgetProgress/ProjectProgress")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/dashboard/budget/civil-project/projectProgressDetail",
    Component: React.lazy(
      () =>
        import("../../Pages/Dashboard/CivilBudgetProgress/projectProgressDetail")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/dashboard/budget/civil-project/projectProgressTaskDetail",
    Component: React.lazy(
      () =>
        import("../../Pages/Dashboard/CivilBudgetProgress/taskProgressDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/enquiry-profile/form/:flag/:EnquiryID/:LoginuserId",
    Component: React.lazy(
      () => import("../../Pages/Share/EnquiryProfileShare")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/enquiry-profile/form/:flag/:EnquiryID/:LoginuserId/thankyou",
    Component: React.lazy(
      () => import("../../Pages/Share/EnquiryProfileShare/thankyouPage")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/enquiry-profile/Feedback/:EnquiryID/:LoginuserId",
    Component: React.lazy(() => import("../../Pages/Share/ShareFeedbackForm")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/enquiry-profile/Feedback/:EnquiryID/:LoginuserId/thankyou",
    Component: React.lazy(
      () => import("../../Pages/Share/ShareFeedbackForm/thankyouPage")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/civil/civil-work-inspection",
    Component: React.lazy(() => import("../../Pages/Civil/WorkInspection")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-inspection/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkInspection/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-inspection-pending/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilWorkInspectionPending/createForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-inspection-pending/view",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/CivilWorkInspectionPending/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-work-inspection-pending",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilWorkInspectionPending")
    ),
    exact: true,
    isNavbar: true
  },
  //QC Training (Sadanand Gadwal)
  {
    path: "/civil/qc-training",
    Component: React.lazy(() => import("../../Pages/Civil/QcTraning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-training/add",
    Component: React.lazy(() => import("../../Pages/Civil/QcTraning/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-training/view",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcTraning/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-training/edit",
    Component: React.lazy(() => import("../../Pages/Civil/QcTraning/editForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd/Project-file-move",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectFileMove")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/TodoCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/TodoCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/TodoCategory/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/TodoCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/TodoCategory/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/TodoCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Material/detail",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Material/details.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/bd-masters/ProjectSubTask",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectSubTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectSubTask/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectSubTask/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/ProjectSubTask/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectSubTask/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/cp-meeting",
    Component: React.lazy(() => import("../../Pages/CRM/CP-Meeting")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/cp-meeting/add",
    Component: React.lazy(() => import("../../Pages/CRM/CP-Meeting/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/cp-meeting/detail",
    Component: React.lazy(
      () => import("../../Pages/CRM/CP-Meeting/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/cp-meeting/edit",
    Component: React.lazy(() => import("../../Pages/CRM/CP-Meeting/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/Preferred-Location",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPreferredLocation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/Preferred-Location/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPreferredLocation/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/Preferred-Location/form-edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPreferredLocation/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-group",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceGroup")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-group/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceGroup/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-group/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceGroup/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-category",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-category/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSourceCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-source",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSource")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-source/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSource/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-source/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSource/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryStatus")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryStatus/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-category",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquirycategory")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-category/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquirycategory/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquirycategory/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-call-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryCallStatus")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-call-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryCallStatus/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-enquiry-call-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryCallStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-item/edit",
    Component: React.lazy(
      () => import("../../Pages/Procurement/IndentItem/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation/edit",
    Component: React.lazy(
      () => import("../../Pages/Procurement/Quotation/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //commit
  {
    path: "/civil/project-material-procurement-schedule/send-approval",
    Component: React.lazy(
      () =>
        import("../../Pages/Civil/ProjectMaterialProcurementSchedule/ScheduleSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-approval",
    Component: React.lazy(
      () => import("../../Pages/Procurement/IndentApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/indent-approval/approval",
    Component: React.lazy(
      () =>
        import("../../Pages/Procurement/IndentApproval/IndentSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation-approval",
    Component: React.lazy(
      () => import("../../Pages/Procurement/QuotationApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation-approval/approval",
    Component: React.lazy(
      () =>
        import("../../Pages/Procurement/QuotationApproval/QuotationSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/quotation-approval/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/QuotationApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order-approval",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrderApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-order-approval/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseOrderApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/crm-dimension",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmDimensionMaster")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-dimension/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmDimensionMaster/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-dimension/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmDimensionMaster/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-release-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmReleaseStatus")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-release-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmReleaseStatus/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-release-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmReleaseStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-premium-type",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSitePremiumType")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-premium-type/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSitePremiumType/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-premium-type/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSitePremiumType/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteStatus")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteStatus/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-investor",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteInvestor")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-investor/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteInvestor/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-site-investor/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmSiteInvestor/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //BD Task Approval - (Budget,Quantity,Schedule) Start
  {
    path: "/civil/civil-project-activity/budget-approval/approval",
    Component: React.lazy(() => import("../../Pages/Civil/BudgetApproval")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/quantity-approval/approval",
    Component: React.lazy(() => import("../../Pages/Civil/QuantityApproval")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/schedule-approval/approval",
    Component: React.lazy(() => import("../../Pages/Civil/ScheduleApproval")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-activity/budget-amendment",
    Component: React.lazy(
      () => import("../../Pages/Civil/Activity/BudgetSendForAmendmentApproval")
    ),
    exact: true,
    isNavbar: true
  },
  //BD Task Approval - (Budget,Quantity,Schedule) End
  {
    path: "/crm/crm-block-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmBlockReason")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-block-reason/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmBlockReason/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/crm-block-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmBlockReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/stock-statement",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockStatment")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/stock-statement/details",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockStatment/stockTransaction")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/grn-items/inspection",
    Component: React.lazy(
      () => import("../../Pages/Procurement/GRN/InspectionForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/GrnCheckPointMaterial",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPointMaterial")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/GrnCheckPointMaterial/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPointMaterial/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/GrnCheckPointMaterial/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPointMaterial/edit")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/prc-master/GrnCheckPoint",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPoint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/GrnCheckPoint/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPoint/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/GrnCheckPoint/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/GrnCheckPoint/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills",
    Component: React.lazy(() => import("../../Pages/Civil/CivilProjectBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectBill/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-project-bills/detail",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectBill/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/civil-bill",
    Component: React.lazy(() => import("../../Pages/Accounts/CivilBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/civil-bill/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CivilBill/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/civil-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CivilBill/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/material-request",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialRequest")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/material-request/add",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialRequest/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/material-request/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialRequest/ReviewForm1.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/material-request/edit",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialRequest/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/store/stock-transfer",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockTransfer")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/store/stock-transfer/edit",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockTransfer/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/store/stock-transfer/add",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockTransfer/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/store/stock-transfer/review-form",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockTransfer/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-setting/master",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilSetting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-setting/master/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilSetting/add")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-setting/master/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/CivilSetting/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Project-setting",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectSetting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Project-setting/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectSetting/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Project-setting/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectSetting/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/civil-Project-setting/ReviewForm",
    Component: React.lazy(
      () => import("../../Pages/Civil/CivilProjectSetting/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  // QC Rejection (Sadanand Gadwal)
  {
    path: "/civil/qc-rejection",
    Component: React.lazy(() => import("../../Pages/Civil/QcRejection")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/measurement-update",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/MeasurementUpdateForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/qc-review",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/QualityCheckReview")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/review-form",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/contract-add",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/QcRejectionEntryForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/qc-rejection/generate-bill",
    Component: React.lazy(
      () => import("../../Pages/Civil/QcRejection/GenerateBillFormQcRejection")
    ),
    exact: true,
    isNavbar: true
  },
  // purchase-invoice
  {
    path: "/procurement/purchase-invoice",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseInvoice")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-invoice/request",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseInvoice/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-invoice/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseInvoice/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-invoice/editForm",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseInvoice/editForm")
    ),
    exact: true,
    isNavbar: true
  },

  // Purchase Invoice Approval
  {
    path: "/accounts/purchase-invoice-approval",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PurchaseInvoiceApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/purchase-invoice-approval/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PurchaseInvoiceApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Channel Partner
  {
    path: "/sales/channel-partner",
    Component: React.lazy(() => import("../../Pages/Accounts/ChannelPartner")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/channel-partner/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChannelPartner/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/channel-partner/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChannelPartner/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/channel-partner/review-form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChannelPartner/ChannelPartnerDetails")
    ),
    exact: true,
    isNavbar: true
  },
  //EPA Sharable
  {
    path: "/EPA-Add/form/:EpaID/:LoginuserId",
    Component: React.lazy(() => import("../../Pages/Share/EPAShare")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/EPA-Add/preview/:EpaID/:LoginuserId",
    Component: React.lazy(
      () => import("../../Pages/Share/EPAShare/previewForm")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/EPA-Add/form/:EpaID/:LoginuserId/thankyou",
    Component: React.lazy(
      () => import("../../Pages/Share/EPAShare/thankyouPage")
    ),
    exact: true,
    isNavbar: false
  },

  {
    path: "/EPA-Add/detail/:EpaID/:LoginuserId",
    Component: React.lazy(
      () => import("../../Pages/Share/EPAShare/detailPage")
    ),
    exact: true,
    isNavbar: false
  },
  //Land-registration
  {
    path: "/business-development/land-registration",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandRegistrationFees")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-registration/new",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandRegistrationFees/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-registration/approval",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/approval")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/issued",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandRegistrationFees/issue")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/draft",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LandRegistrationFees/draft")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/request",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/request")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/approve",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/approve")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/settlementRequest",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/settlementRequest")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/settlementApprove",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/settlementApprove")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/business-development/land-registration/issueNonRefund",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/issueNonRefund")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/land-registration/detail",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LandRegistrationFees/detail")
    ),
    exact: true,
    isNavbar: true
  },

  //site-registration
  {
    path: "/business-development/site-registration",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/form",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/edit",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/view",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SiteRegistration/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/settlement-Approval",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SiteRegistration/settlementApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/request",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration/request")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/issueNonRefund",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SiteRegistration/issueNonRefund")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/issued",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration/issue")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/settlementRequest",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SiteRegistration/settlementRequest")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/settlementApprove",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/SiteRegistration/settlementApprove")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/business-development/site-registration/detail",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/SiteRegistration/detail")
    ),
    exact: true,
    isNavbar: true
  },
  //Delivery-Challan
  {
    path: "/procurement/delivery-challan-request",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-request/request",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallan/DcTransferRequest")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-request/add",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallan/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-request/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallan/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-request/editForm",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallan/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-approved",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallanApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/delivery-challan-approved/view",
    Component: React.lazy(
      () => import("../../Pages/Procurement/DeliveryChallanApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Channel-Partner-Report
  {
    path: "/reports/channel-partner-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReport/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report/leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReport/Leads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReport/SiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report/sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReport/Sales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReport/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/reports/channel-partner-report-detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReportDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report-detail/leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReportDetail/Leads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report-detail/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReportDetail/SiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report-detail/sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReportDetail/Sales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-report-detail/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPSalesReportDetail/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  //Source-Sales-Report
  {
    path: "/reports/source-sales-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report/leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReport/Leads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReport/SiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report/sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReport/Sales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReport/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report-detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReportDetail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report-detail/leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReportDetail/Leads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report-detail/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReportDetail/SiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report-detail/sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReportDetail/Sales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/source-sales-report-detail/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/SourcesSalesReportDetail/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  //Channel-Partner-Onboard
  {
    path: "/reports/channel-partner-onboard",
    Component: React.lazy(() => import("../../Pages/Reports/CPOnboard")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-onboard/cp-detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPOnboard/CPOnboardDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-onboard/leads",
    Component: React.lazy(() => import("../../Pages/Reports/CPOnboard/Leads")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-onboard/site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPOnboard/SiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-onboard/sales",
    Component: React.lazy(() => import("../../Pages/Reports/CPOnboard/Sales")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/channel-partner-onboard/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/CPOnboard/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  //Pre-Sales-Report
  {
    path: "/reports/pre-sales-report",
    Component: React.lazy(() => import("../../Pages/Reports/PreSalesReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReport/Leads")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/reports/pre-sales-report/over-due-lead",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReport/OverDueLead")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-detail/lead",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/Leads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-detail/overDue",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/OverDueReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-details",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/reports/pre-sales-report-actual-site-visit-pevious-enquiry",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/PreSalesReportDetails/SiteVisitPreviousEnquiry")
    ),
    exact: true,
    isNavbar: true
  },
  //Liaison-Master
  {
    path: "/liaison-Master/ProjectProcessMap",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectProcessMap")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/liaison-Master/ProjectProcessMap/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectProcessMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison-Master/ProjectProcessMap/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectProcessMap/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //Notification todo and Process
  {
    path: "/todo-pending/:LoginuserId",
    Component: React.lazy(() => import("../../Pages/Share/TodoShare")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/todo-pending-detail/:LoginuserId/:id",
    Component: React.lazy(
      () => import("../../Pages/Share/TodoShare/TodoDetail")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/bd-pending-task/:LoginuserId",
    Component: React.lazy(() => import("../../Pages/Share/BDTaskShare")),
    exact: true,
    isNavbar: false
  },
  {
    path: "/bd-pending-task-detail/:LoginuserId/:id",
    Component: React.lazy(
      () => import("../../Pages/Share/BDTaskShare/BDTaskShareDetail")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/Liaison-process-share/:LoginuserId",
    Component: React.lazy(
      () => import("../../Pages/Share/LiaisonProcessShare")
    ),
    exact: true,
    isNavbar: false
  },
  {
    path: "/Liaison-process-share-detail/:LoginuserId/:id",
    Component: React.lazy(
      () =>
        import("../../Pages/Share/LiaisonProcessShare/LiaisonProcessShareDetail.jsx")
    ),
    exact: true,
    isNavbar: false
  },
  //goverment-fees
  {
    path: "/accounts/government-fees",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/new",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/draft",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/draft")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/pending",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/pending")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/approved",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/approved")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/account-approved",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/accountApproved")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/issued",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/issued")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/government-fees/paid",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/paid")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/advanceApproved",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/advanceApproved")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/accounted",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/accounted")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/approval",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/approval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/government-fees/editForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/GovernmentFees/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //GovernmentFeesItem
  {
    path: "/liaison-master/GovernmentFeesItem",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/GovernmentFeesItem")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison-master/GovernmentFeesItem/new",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/GovernmentFeesItem/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/liaison-master/GovernmentFeesItem/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/GovernmentFeesItem/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //retention-percentage
  {
    path: "/Account/retention-percentage",
    Component: React.lazy(
      () => import("../../Pages/Accounts/RetentionPercentage")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Account/retention-percentage/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/RetentionPercentage/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Account/retention-percentage/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/RetentionPercentage/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //My Dashboard
  {
    path: "/dashboard/main-dashboard",
    Component: React.lazy(() => import("../../Pages/Dashboard/MainDashboard")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/my-dashboard",
    Component: React.lazy(() => import("../../Pages/Dashboard/MyDashboard")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/project-dashboard",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/ProjectDashboard")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/accountable-dashboard",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/AccountableDashboard")
    ),
    exact: true,
    isNavbar: true
  },
  //Vendor Ledger
  {
    path: "/account/vendor-ledger",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorLedger/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vendor-ledger/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorLedger/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vendor-ledger/PaidAmount",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorLedger/PaidAmount")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vendor-ledger/PaymentPayable",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorLedger/PaymentPayable")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/account/vendor-ledger/PaymentStatement",
  //   Component: React.lazy(
  //     () => import("../../Pages/Accounts/VendorLedger/PaymentStatement")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/account/vendor-ledger-items/Statement",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VendorLedger/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Vendor Payment Request
  {
    path: "/account/payment-request",
    Component: React.lazy(() => import("../../Pages/Accounts/PaymentRequest")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequest/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request/reviewform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequest/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequest/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request/send-for-approval",
    Component: React.lazy(
      () =>
        import("../../Pages/Accounts/PaymentRequest/PaymentRequestSendForApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request/approve",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequest/PaymentRequestApprove")
    ),
    exact: true,
    isNavbar: true
  },
  //Purchase Return
  {
    path: "/procurement/purchase-return",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-return/form",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-return/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn/detail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-return/editForm",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-return/pending",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn/pending")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/purchase-return/approve",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturn/approved")
    ),
    exact: true,
    isNavbar: true
  },
  //Payment Request Amount
  {
    path: "/account/payment-request-account",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequestAccount")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request-account/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequestAccount/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request-account/reviewform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentRequestAccount/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-request-account/pay",
    Component: React.lazy(
      () =>
        import("../../Pages/Accounts/PaymentRequestAccount/PaymentRequestPay")
    ),
    exact: true,
    isNavbar: true
  },
  //Account Payment Paid
  {
    path: "/accounts/account-payment-tally",
    Component: React.lazy(
      () => import("../../Pages/Accounts/AccountPaymentTally/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/account-payment-tally/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/AccountPaymentTally/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //Account Payment Realize
  {
    path: "/accounts/account-payment-realization",
    Component: React.lazy(
      () => import("../../Pages/Accounts/AccountPaymentRealization")
    ),
    exact: true,
    isNavbar: true
  },

  //Material Return
  {
    path: "/procurement/material-return",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialReturn")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/material-return/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/MaterialReturn/detail")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/follow-up",
    Component: React.lazy(() => import("../../Pages/CRM/FollowUp")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/tds-deduction",
    Component: React.lazy(() => import("../../Pages/Accounts/TdsDeduction")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/tds-deduction/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/TdsDeduction/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/tds-deduction/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/TdsDeduction/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Module
  //Sales quotation
  {
    path: "/sales/sales-quotation",
    Component: React.lazy(() => import("../../Pages/Sales/SalesQuotation")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-quotation/request",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesQuotation/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-quotation/detail",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesQuotation/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-quotation/editForm",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesQuotation/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Quotation Approval
  {
    path: "/sales/sales-quotation-approval",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesQuotationApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-quotation-approval/detail",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesQuotationApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  // Sales Invoice Approval
  {
    path: "/accounts/sales-invoice-approval",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalesInvoiceApproval")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/sales-invoice-approval/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalesInvoiceApproval/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Delivery-Challan
  //  {
  //   path: "/sales/delivery-challan-request",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Sales/DeliveryChallan")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/sales/delivery-challan-request/request",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Sales/DeliveryChallan/DcTransferRequest")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/sales/delivery-challan-request/add",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Sales/DeliveryChallan/form")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/sales/delivery-challan-request/detail",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Sales/DeliveryChallan/ReviewForm")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/sales/delivery-challan-request/editForm",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Sales/DeliveryChallan/editForm")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },

  // Expenses Invoice
  {
    path: "/accounts/expenses-invoice",
    Component: React.lazy(() => import("../../Pages/Accounts/ExpensesInvoice")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/expenses-invoice/request",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ExpensesInvoice/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/expenses-invoice/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ExpensesInvoice/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/expenses-invoice/editForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ExpensesInvoice/editForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/expenses-invoice/updateForm",
    Component: React.lazy(
      () =>
        import("../../Pages/Accounts/ExpensesInvoice/expenseInvoiceUpdateForm")
    ),
    exact: true,
    isNavbar: true
  },

  //HR Master User Bata
  {
    path: "/hr/master/user-bata",
    Component: React.lazy(() => import("../../Pages/Master/HRMaster/UserBata")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/master/user-bata/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserBata/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/master/user-bata/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserBata/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/report/sales-review-report/actual-agreement",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Reports/SalesReviewReport/ActualAgreement")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/report/sales-review-report/actual-registration",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Reports/SalesReviewReport/ActualRegistration")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/report/sales-review-report/actual-agreement",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualAgreement")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/actual-registration",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/ActualRegistration")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/report/sales-team-review-report/actual-registration",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualRegistration")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-team-review-report/actual-agreement",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesTeamReview/ActualAgreement")
    ),
    exact: true,
    isNavbar: true
  },
  //mar 6 presalesreport
  {
    path: "/reports/pre-sales-report-planned-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/PlannedCall")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-actual-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/ActualCall")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-actual-site-visit",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/ActualSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-actual-sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/ActualSales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/pre-sales-report-cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/PreSalesReportDetails/Cancellation")
    ),
    exact: true,
    isNavbar: true
  },

  //lead report
  {
    path: "/reports/lead-report",
    Component: React.lazy(() => import("../../Pages/Reports/LeadReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/tbf-detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/TbfDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/site-lead",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/sitevisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/actual-sales",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/actualsales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/cancellation",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/cancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/source-summary",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/SourceSummary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/lead-report/sub-source-summary",
    Component: React.lazy(
      () => import("../../Pages/Reports/LeadReport/subSourceSummary")
    ),
    exact: true,
    isNavbar: true
  },

  //call summary

  // ----pk----Call-Summary----------
  {
    path: "/report/call-summary-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/total-enquiry",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/TotalEnquiry.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/total-answered",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/TotalAnswered.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/total-unanswered",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/TotalUnAnswered.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/follow-up",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/FollowUp.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/follow-up-unanswered",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/FollowUpUnAnswered.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/fresh-answered",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/FreshAnswered.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/call-summary-report/fresh-un-answered",
    Component: React.lazy(
      () => import("../../Pages/Reports/CallSummary/FreshUnAnswered.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //brand
  {
    path: "/prc-master/brand",
    Component: React.lazy(() => import("../../Pages/Master/Procurement/Brand")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/brand/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Brand/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/brand/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/Brand/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //material brand
  {
    path: "/prc-master/material-brand",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/MaterialBrand")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/prc-master/material-brand/add",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/MaterialBrand/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/prc-master/material-brand/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/MaterialBrand/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/procurement-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProcurementReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/procurement-report/detail",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProcurementReport/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //civil budget report
  {
    path: "/reports/civil-budget-project-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/CivilBudgetProjectReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-budget-project-report-admin-expense",
    Component: React.lazy(
      () => import("../../Pages/Reports/CivilBudgetProjectReport/AdminExpense")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-budget-project-report-petty-cash",
    Component: React.lazy(
      () => import("../../Pages/Reports/CivilBudgetProjectReport/PettyCash")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-budget-wbs-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/CivilBudgetWbsReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/CivilActivityBudgetReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report-details",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/CivilActivityBudgetReport/MaterialDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report-material-details",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/CivilActivityBudgetReport/ActualMaterialReport")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report-machine-details",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/CivilActivityBudgetReport/ActualMachine")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report-man-power-details",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/CivilActivityBudgetReport/ActualManPower")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/civil-activity-budget-report-contract-details",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/CivilActivityBudgetReport/ActualContract")
    ),
    exact: true,
    isNavbar: true
  },

  //full & final
  {
    path: "/hr/full-final",
    Component: React.lazy(() => import("../../Pages/HR/FullAndFinal")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/full-final/details",
    Component: React.lazy(
      () => import("../../Pages/HR/FullAndFinal/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/full-final/bill",
    Component: React.lazy(
      () => import("../../Pages/HR/FullAndFinal/billPrint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/full-final/edit",
    Component: React.lazy(() => import("../../Pages/HR/FullAndFinal/editForm")),
    exact: true,
    isNavbar: true
  },

  //  Company Account Map Vishal

  {
    path: "/account/company-account",
    Component: React.lazy(() => import("../../Pages/Accounts/CompanyAccount")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/company-account/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CompanyAccount/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/company-account/editform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CompanyAccount/EditForm")
    ),
    exact: true,
    isNavbar: true
  },

  //project land
  {
    path: "/business-development/land-bank",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/ProjectLand")
    ),
    exact: true,
    isNavbar: true
  },

  //site summary
  {
    path: "/reports/site-summary",
    Component: React.lazy(() => import("../../Pages/Reports/SiteSummary")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/site-summary/site-details",
    Component: React.lazy(
      () => import("../../Pages/Reports/SiteSummary/TbfDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/site-summary/sold-details",
    Component: React.lazy(
      () => import("../../Pages/Reports/SiteSummary/actualsales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/site-summary/unsold-details",
    Component: React.lazy(
      () => import("../../Pages/Reports/SiteSummary/cancellation")
    ),
    exact: true,
    isNavbar: true
  },

  //Loan Summary
  {
    path: "/business-development/loan-summary",
    Component: React.lazy(
      () => import("../../Pages/BusinessDevelopment/LoanSummary")
    ),
    exact: true,
    isNavbar: true
  },

  //work order category
  {
    path: "/civil/work-order-category",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrderCategory/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/work-order-category/add",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrderCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/work-order-category/detail",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrderCategory/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/work-order-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Civil/WorkOrderCategory/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //org chart
  {
    path: "/org-chart",
    Component: React.lazy(() => import("../../Pages/Reports/orgChart")),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/dashboard/project-process",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Dashboard/CivilProjectProgress/index.jsx")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/dashboard/project-process/wbs",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Dashboard/CivilProjectProgress/projectProgressDetail")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/dashboard/project-process/activity",
  //   Component: React.lazy(() =>
  //     import(
  //       "../../Pages/Dashboard/CivilProjectProgress/"
  //     )
  //   ),
  //   exact: true,
  //   isNavbar: true
  // }
  {
    path: "/dashboard/civil-project-progress",
    Component: React.lazy(
      () =>
        import("../../Pages/Dashboard/CivilProjectProcessDashboard/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/civil-project-progress/wbs",
    Component: React.lazy(
      () => import("../../Pages/Dashboard/CivilProjectProcessDashboard/wbs.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/dashboard/civil-project-progress/activity",
    Component: React.lazy(
      () =>
        import("../../Pages/Dashboard/CivilProjectProcessDashboard/taskProgressDetail.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //salary advance
  {
    path: "/hr/SalaryAdvanceRequest",
    Component: React.lazy(() => import("../../Pages/HR/SalaryAdvanceRequest")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/Form",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/Form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/SalaryAdvanceRequest/edit",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/draft",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/draft")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/approved",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/approved")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/issued",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/issued")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/settled",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/settled")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/rejected",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/paid")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/SalaryAdvanceRequest/settlement",
    Component: React.lazy(
      () => import("../../Pages/HR/SalaryAdvanceRequest/settlement")
    ),
    exact: true,
    isNavbar: true
  },

  //petty cash
  {
    path: "/HR/petty-cash",
    Component: React.lazy(() => import("../../Pages/Accounts/PettyCash")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/petty-cash/form",
    Component: React.lazy(() => import("../../Pages/Accounts/PettyCash/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/petty-cash/review-form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PettyCash/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/petty-cash/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PettyCash/editForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Civil Project Process Dashboard Horizontal
  {
    path: "/dashboard/civil-project-progress-hor",
    Component: React.lazy(
      () =>
        import("../../Pages/Dashboard/CivilProjectProcessDashboardHorizontal")
    ),
    exact: true,
    isNavbar: true
  },
  //hr
  {
    path: "/hr/admin-setting-value",
    Component: React.lazy(() => import("../../Pages/HR/AdminSettingValue")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting-value-form",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSettingValue/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting-value-editform",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSettingValue/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting-item",
    Component: React.lazy(() => import("../../Pages/HR/AdminSettingItem")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting-item/form",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSettingItem/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting-item/edit",
    Component: React.lazy(() => import("../../Pages/HR/AdminSettingItem/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting",
    Component: React.lazy(() => import("../../Pages/HR/AdminSetting")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting/form",
    Component: React.lazy(() => import("../../Pages/HR/AdminSetting/form.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting/edit",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSetting/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //UOM CONVERSION
  {
    path: "/civil/uom-conversion",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/UOMConversion")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/uom-conversion-form",
    Component: React.lazy(
      () => import("../../Pages/Master/CivilMaster/UOMConversion/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/civil/uom-conversion-editform",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CivilMaster/UOMConversion/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/admin-setting/details",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSetting/details.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/admin-setting/update-value",
    Component: React.lazy(
      () => import("../../Pages/HR/AdminSetting/editHistory.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //payment category
  {
    path: "/account/payment-category",
    Component: React.lazy(() => import("../../Pages/Accounts/PaymentCategory")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-category/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/payment-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //salary jv and salary slip
  {
    path: "/HR/consultant-bill",
    Component: React.lazy(() => import("../../Pages/HR/ConsultantBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/consultant-bill/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/HR/ConsultantBill/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account/salary-expense",
    Component: React.lazy(() => import("../../Pages/Accounts/SalaryJV")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/salary-expense/review-form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalaryJV/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/salary-expense/other-deduction",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalaryJV/otherDeduction")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/salary-expense/employer-pf",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalaryJV/salaryEmployerpf")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/salary-expense/employer-esi",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalaryJV/salaryEmployerEsi")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/salary-expense/salary-advance",
    Component: React.lazy(
      () => import("../../Pages/Accounts/SalaryJV/salaryAdvanceEmployer")
    ),
    exact: true,
    isNavbar: true
  },

  // Cost Center Category //
  {
    path: "/account/cost-center-category",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CostCenterCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cost-center-category/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CostCenterCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cost-center-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CostCenterCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Cost Center //
  {
    path: "/account/cost-center",
    Component: React.lazy(() => import("../../Pages/Accounts/CostCenter")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cost-center/form",
    Component: React.lazy(() => import("../../Pages/Accounts/CostCenter/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cost-center/edit",
    Component: React.lazy(() => import("../../Pages/Accounts/CostCenter/edit")),
    exact: true,
    isNavbar: true
  },
  // Expenses Invoice Account
  {
    path: "/accounts/expenses-invoice-account",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ExpensesInvoiceAccount")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/expenses-invoice-account/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ExpensesInvoiceAccount/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  // ----------------------Compant Master---------------
  {
    path: "/Procurement/company-master",
    Component: React.lazy(() => import("../../Pages/Accounts/CompanyMaster")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Procurement/company-master/new",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CompanyMaster/Form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Procurement/company-master/update",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CompanyMaster/CompanyDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/Procurement/company-master/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CompanyMaster/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //payment authority
  {
    path: "/admin/Payment-authenticate",
    Component: React.lazy(
      () => import("../../Pages/Admin/PaymentAuthenticate")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/Payment-authenticate/form",
    Component: React.lazy(
      () => import("../../Pages/Admin/PaymentAuthenticate/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/Payment-authenticate/edit",
    Component: React.lazy(
      () => import("../../Pages/Admin/PaymentAuthenticate/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //payment receit
  {
    path: "/accounts/payment-receit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentReceit/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/payment-receit/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentReceit/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/payment-receit/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentReceit/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/payment-receit/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PaymentReceit/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vehicle-fuel-bill",
    Component: React.lazy(() => import("../../Pages/Accounts/VehicleFuelBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vehicle-fuel-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VehicleFuelBill/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vehicle-fuel-bill/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VehicleFuelBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/vehicle-fuel-bill/Pay",
    Component: React.lazy(
      () => import("../../Pages/Accounts/VehicleFuelBill/VehicalFuelBillPay")
    ),
    exact: true,
    isNavbar: true
  },

  //form 16
  {
    path: "/hr/form-16",
    Component: React.lazy(() => import("../../Pages/HR/Form16")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/form-16/form",
    Component: React.lazy(() => import("../../Pages/HR/Form16/form")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/form-16/edit",
    Component: React.lazy(() => import("../../Pages/HR/Form16/edit")),
    exact: true,
    isNavbar: true
  },

  //enquiry follow up reason
  {
    path: "/crm-master/enquiry-follow-up-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryFollowUpReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/enquiry-follow-up-reason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryFollowUpReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/enquiry-follow-up-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmEnquiryFollowUpReason/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //unused crm site face
  // {
  //   path: "/crm-master/site-face",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/CrmMaster/CrmSiteFace")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/crm-master/site-face/form",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/CrmMaster/CrmSiteFace/form")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/crm-master/site-face/edit",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/CrmMaster/CrmSiteFace/edit")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },

  //Meeting
  {
    path: "/admin/meeting",
    Component: React.lazy(() => import("../../Pages/Admin/Meeting")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/meeting/add",
    Component: React.lazy(() => import("../../Pages/Admin/Meeting/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/meeting/detail",
    Component: React.lazy(() => import("../../Pages/Admin/Meeting/Reviewform")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/meeting/edit",
    Component: React.lazy(() => import("../../Pages/Admin/Meeting/edit")),
    exact: true,
    isNavbar: true
  },
  // ----------ChequeBook----------
  {
    path: "/account/cheque-book",
    Component: React.lazy(() => import("../../Pages/Accounts/ChequeBook")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book/form",
    Component: React.lazy(() => import("../../Pages/Accounts/ChequeBook/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeBook/details.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book/editform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeBook/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  // ----------ChequeBookUsage----------
  {
    path: "/account/cheque-book-usage",
    Component: React.lazy(() => import("../../Pages/Accounts/ChequeBookUsage")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book-usage/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeBookUsage/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book-usage/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeBookUsage/details.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-book-usage/editform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeBookUsage/EditForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Vehicle
  {
    path: "/hr/master/Vehicle-Registration",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/VehicleRegistration")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/master/Vehicle-Registration/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/VehicleRegistration/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/master/Vehicle-Registration/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/VehicleRegistration/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //lead list
  {
    path: "/crm/promotional-lead",
    Component: React.lazy(() => import("../../Pages/CRM/LeadList")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/promotional-lead/add-lead",
    Component: React.lazy(() => import("../../Pages/CRM/LeadList/form")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/promotional-lead/bulk-assign",
    Component: React.lazy(() => import("../../Pages/CRM/LeadList/bulkAssign")),
    exact: true,
    isNavbar: true
  },

  //promotional activity
  {
    path: "/crm-master/promotional-activity",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPromotionalActivity")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/promotional-activity/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPromotionalActivity/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/promotional-activity/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmPromotionalActivity/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //site-visit
  {
    path: "/crm/site-visit",
    Component: React.lazy(() => import("../../Pages/CRM/SiteVisit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/site-visit/add",
    Component: React.lazy(() => import("../../Pages/CRM/SiteVisit/form")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account-master/card",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Card")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/card/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Card/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/card/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Card/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //Item Category
  {
    path: "/prc-master/Category",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/CategoryItem")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Category/new",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/CategoryItem/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/prc-master/Category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/Procurement/CategoryItem/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Professional Tax Master

  {
    path: "/hr-master/ProfessionalTaxMaster",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProfessionalTaxMaster")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/ProfessionalTaxMaster/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProfessionalTaxMaster/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/ProfessionalTaxMaster/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProfessionalTaxMaster/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  // HR Provident Fund
  {
    path: "/hr-master/ProvidentFund",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProvidentFund")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/ProvidentFund/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProvidentFund/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/ProvidentFund/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ProvidentFund/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  // Employee State Insurance
  {
    path: "/hr-master/EmployeeStateInsurance",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeStateInsurance")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/EmployeeStateInsurance/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeStateInsurance/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/EmployeeStateInsurance/edit-form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/EmployeeStateInsurance/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  // Leave Summary
  {
    path: "/HR/LeaveSummary",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveSummary")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/LeaveSummary/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveSummary/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/HR/LeaveSummary/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/LeaveSummary/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  // User Shift
  {
    path: "/hr-master/user-shift",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserShift")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/user-shift/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserShift/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/user-shift/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserShift/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  //salary component
  {
    path: "/hr-master/Salary-Component",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryComponent")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/Salary-Component/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryComponent/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/Salary-Component/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryComponent/formEdit")
    ),
    exact: true,
    isNavbar: true
  },

  //DD Request
  {
    path: "/accounts/dd-request",
    Component: React.lazy(() => import("../../Pages/Accounts/DDRequest")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/dd-request/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/DDRequest/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account/petty-cash",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PettyCashAccounts")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/petty-cash/review-form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/PettyCashAccounts/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account/password-item",
    Component: React.lazy(() => import("../../Pages/HR/PasswordItem")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/password-item/form",
    Component: React.lazy(() => import("../../Pages/HR/PasswordItem/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/password-item/edit",
    Component: React.lazy(() => import("../../Pages/HR/PasswordItem/edit")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account/company-password",
    Component: React.lazy(() => import("../../Pages/HR/CompanyPassword")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/company-password/add",
    Component: React.lazy(() => import("../../Pages/HR/CompanyPassword/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/company-password/edit",
    Component: React.lazy(() => import("../../Pages/HR/CompanyPassword/edit")),
    exact: true,
    isNavbar: true
  },
  //Accounts Director

  {
    path: "/account-master/Director",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Director")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/Director/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Director/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/Director/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Director/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/Director/detail",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Director/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Accounts DIN Verification

  {
    path: "/account-master/DinVerification",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/DinVerification")
    ),
    exact: true,
    isNavbar: true
  },
  // {
  //   path: "/account-master/DinVerification/edit-form",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Master/AccountMaster/DinVerification/edit")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/account-master/DinVerification/detail",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/AccountMaster/DinVerification/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/review-form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/Card/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //QC Stages (Master)
  {
    path: "/qc/qc-stage",
    Component: React.lazy(() => import("../../Pages/Master/QCMaster/QcStage")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-stage/add",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStage/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-stage/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStage/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //QC Point (Master)
  {
    path: "/qc/qc-checkpoint",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPoint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpoint/form",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPoint/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpoint/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPoint/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //check point option
  {
    path: "/qc/qc-checkpointoption",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOption")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpointoption/form",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOption/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpointoption/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOption/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpointoption-map",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOptionMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpointoption-map/form",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOptionMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-checkpointoption-map/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcCheckPointOptionMap/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //qc check point (Master)
  {
    path: "/qc/qc-stage-checkpoint-map",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageCheckPointMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-stage-checkpoint-map/form",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageCheckPointMap/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-stage-checkpoint-map/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageCheckPointMap/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //QC Request (Main)
  {
    path: "/qc/qc-request",
    Component: React.lazy(() => import("../../Pages/QC/QcRequest")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/add",
    Component: React.lazy(() => import("../../Pages/QC/QcRequest/form.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/edit",
    Component: React.lazy(
      () => import("../../Pages/QC/QcRequest/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcRequest/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/details",
    Component: React.lazy(() => import("../../Pages/QC/QcRequest/Review.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/preview",
    Component: React.lazy(
      () => import("../../Pages/QC/QcRequest/previewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-request/question-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcRequest/questionForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // -------------QC_Review (Main)----------------------
  {
    path: "/qc/qc-review",
    Component: React.lazy(() => import("../../Pages/QC/QcReview")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-review/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcReview/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-review/details",
    Component: React.lazy(() => import("../../Pages/QC/QcReview/Review.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-review/preview",
    Component: React.lazy(
      () => import("../../Pages/QC/QcReview/previewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-review/question-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcReview/questionForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // -------------QC_Inspection_Approved (Main)----------------------
  {
    path: "/qc/qc-inspection_approval",
    Component: React.lazy(() => import("../../Pages/QC/QcInspectionApproval")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-inspection_approval/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInspectionApproval/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-inspection_approval/details",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInspectionApproval/Review.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-inspection_approval/preview",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInspectionApproval/previewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-inspection_approval/question-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInspectionApproval/questionForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // -------------QC Instruction (Main)---------------------
  {
    path: "/qc/qc-instruction",
    Component: React.lazy(() => import("../../Pages/QC/QcInstruction")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-instruction/add",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInstruction/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-instruction/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInstruction/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-instruction/edit",
    Component: React.lazy(
      () => import("../../Pages/QC/QcInstruction/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // -------------Instruction (Main)----------------------
  {
    path: "/qc/instruction",
    Component: React.lazy(() => import("../../Pages/QC/Instruction/index.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/instruction/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/Instruction/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // QC Walkthrough (Main)
  {
    path: "/qc/qc-walkthrough",
    Component: React.lazy(() => import("../../Pages/QC/Qcwalkthrough")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-walkthrough/add",
    Component: React.lazy(
      () => import("../../Pages/QC/Qcwalkthrough/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-walkthrough/review-form",
    Component: React.lazy(
      () => import("../../Pages/QC/Qcwalkthrough/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-walkthrough/edit",
    Component: React.lazy(
      () => import("../../Pages/QC/Qcwalkthrough/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //stock aging
  {
    path: "/procurement/stock-ageing",
    Component: React.lazy(() => import("../../Pages/Procurement/StockAging")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/stock-ageing/details",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockAging/stockTransaction")
    ),
    exact: true,
    isNavbar: true
  },
  //consolidated new report
  {
    path: "/reports/consolidated-report",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/BDConsolidatedNewReport/BDConsolidatedReport")
    ),
    exact: true,
    isNavbar: false
  },
  //MD Dashboard
  {
    path: "/dashboard/md-dashboard",
    Component: React.lazy(() => import("../../Pages/Dashboard/MDDashboard")),
    exact: true,
    isNavbar: true
  },
  //ORM
  {
    path: "/orm/land-acquisition",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/bd",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/bdORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/liaison-process",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/liaisonProcessORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/liaison-document",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/liaisonDocumentORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/survey",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/surveyORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/boundary-dispute",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/boundaryDisputeORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/legal-task",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/legalTask")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/land-acquisition/court-case",
    Component: React.lazy(
      () => import("../../Pages/ORM/LandAcquisitionORM/courtCaseORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/civil/schedule",
    Component: React.lazy(
      () => import("../../Pages/ORM/CivilScheduleORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/civil/budget",
    Component: React.lazy(() => import("../../Pages/ORM/CivilBudgetORM")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/civil/progress-video",
    Component: React.lazy(
      () => import("../../Pages/ORM/CivilProgressVideoORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/project-progess",
    Component: React.lazy(
      () => import("../../Pages/ORM/ProjectProgessORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/sales",
    Component: React.lazy(() => import("../../Pages/ORM/SalesORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/pre-sales",
    Component: React.lazy(() => import("../../Pages/ORM/PreSalesORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/marketing",
    Component: React.lazy(() => import("../../Pages/ORM/MarketingORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm",
    Component: React.lazy(() => import("../../Pages/ORM/CrmORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/collection",
    Component: React.lazy(() => import("../../Pages/ORM/CrmORM/collectionORM")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/customer-ticket",
    Component: React.lazy(
      () => import("../../Pages/ORM/CrmORM/customerTicketORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/agreement",
    Component: React.lazy(() => import("../../Pages/ORM/CrmORM/agreementORM")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/registration",
    Component: React.lazy(
      () => import("../../Pages/ORM/CrmORM/registrationORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/cancellation",
    Component: React.lazy(
      () => import("../../Pages/ORM/CrmORM/cancellationORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/project-handover",
    Component: React.lazy(
      () => import("../../Pages/ORM/CrmORM/projectHandoverORM")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/crm/collection-projection",
    Component: React.lazy(
      () => import("../../Pages/ORM/CrmORM/collectionProjectionORM.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/procurement",
    Component: React.lazy(() => import("../../Pages/ORM/ProcurementORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/store",
    Component: React.lazy(() => import("../../Pages/ORM/StoreORM")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/civil",
    Component: React.lazy(() => import("../../Pages/ORM/CivilORM/index")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/orm/hr",
    Component: React.lazy(() => import("../../Pages/ORM/HrORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/compliance-calendar",
    Component: React.lazy(() => import("../../Pages/ORM/ComplianceORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/apf",
    Component: React.lazy(() => import("../../Pages/ORM/APFORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/apf-documentation",
    Component: React.lazy(
      () => import("../../Pages/ORM/APFDocumentationORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/apf-legal",
    Component: React.lazy(
      () => import("../../Pages/ORM/APFLegalOpinionORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/apf-approval",
    Component: React.lazy(() => import("../../Pages/ORM/APFApprovalORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/project-finance",
    Component: React.lazy(() => import("../../Pages/ORM/ProjectLoanORM/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/orm/qc",
    Component: React.lazy(() => import("../../Pages/ORM/QcORM")),
    exact: true,
    isNavbar: true
  },

  //Stock Summary
  {
    path: "/procurement/stock-summary",
    Component: React.lazy(() => import("../../Pages/Procurement/StockSummary")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/procurement/stock-summary/Details",
    Component: React.lazy(
      () => import("../../Pages/Procurement/StockSummary/stockTransaction")
    ),
    exact: true,
    isNavbar: true
  },
  //EOI Price
  {
    path: "/crm-master/eoi-price",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/EOIPrice")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/eoi-price/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/EOIPrice/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/eoi-price/detail",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/EOIPrice/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/eoi-price/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/EOIPrice/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //EOI
  {
    path: "/crm/EOI",
    Component: React.lazy(() => import("../../Pages/CRM/EOI")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/EOI/add",
    Component: React.lazy(() => import("../../Pages/CRM/EOI/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/EOI/detail",
    Component: React.lazy(() => import("../../Pages/CRM/EOI/Reviewform")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/lease",
    Component: React.lazy(() => import("../../Pages/Accounts/Lease")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/lease/form",
    Component: React.lazy(() => import("../../Pages/Accounts/Lease/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/lease/reviewForm",
    Component: React.lazy(() => import("../../Pages/Accounts/Lease/draft")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/lease/edit",
    Component: React.lazy(() => import("../../Pages/Accounts/Lease/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/service-type",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ServiceType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/service-type/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ServiceType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/service-type/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/ServiceType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/VehicleService/vehicle-service-pay/approve",
    Component: React.lazy(
      () => import("../../Pages/HR/VehicleService/VehicalServicePay")
    ),
    exact: true,
    isNavbar: true
  },

  // ReraApplication

  {
    path: "/accounts/rera-application",
    Component: React.lazy(() => import("../../Pages/Accounts/ReraApplication")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-application/add",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraApplication/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-application/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraApplication/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-application/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraApplication/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-queryform/add",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraApplication/formquery.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  // Rera--Query
  {
    path: "/accounts/rera-query",
    Component: React.lazy(() => import("../../Pages/Accounts/ReraQuery")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-query/add",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraQuery/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-query/review",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraQuery/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-filing",
    Component: React.lazy(() => import("../../Pages/Accounts/ReraFiling")),
    exact: true,
    isNavbar: true
  },
  // Rera--Filing
  {
    path: "/accounts/rera-filing",
    Component: React.lazy(() => import("../../Pages/Accounts/ReraFiling")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rera-filing/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ReraFiling/reviewForm2.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  //Accounts Compliance Category **

  {
    path: "/compliance-master/ComplianceCategory",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/ComplianceCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/ComplianceCategory/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/ComplianceMaster/ComplianceCategory/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/ComplianceCategory/edit-form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/ComplianceMaster/ComplianceCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //Accounts Compliance SubCategory

  // {
  //   path: "/compliance-master/ComplianceSubCategory",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Master/AccountMaster/ComplianceSubCategory")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/compliance-master/ComplianceSubCategory/form",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Master/AccountMaster/ComplianceSubCategory/form")
  //   ),

  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/compliance-master/ComplianceSubCategory/edit-form",
  //   Component: React.lazy(() =>
  //     import("../../Pages/Master/AccountMaster/ComplianceSubCategory/edit")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },

  // Compliance Module (SVM)

  {
    path: "/compliance/Compliance",
    Component: React.lazy(() => import("../../Pages/Compliance/Compliance")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance/Compliance/form",
    Component: React.lazy(
      () => import("../../Pages/Compliance/Compliance/form")
    ),

    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance/Compliance/Review-form",
    Component: React.lazy(
      () => import("../../Pages/Compliance/Compliance/ReviewForm")
    ),
    isNavbar: true
  },
  {
    path: "/compliance/Compliance/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Compliance/Compliance/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Accounts Compliance Item
  {
    path: "/compliance-master/ComplianceItem",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/ComplianceItem")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/ComplianceItem/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/ComplianceItem/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/ComplianceItem/form",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/ComplianceItem/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/ComplianceItem/Reviewform",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/ComplianceMaster/ComplianceItem/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Accounts Company Compliance
  {
    path: "/compliance-master/CompanyCompliance",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/CompanyCompliance")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/CompanyCompliance/edit-form",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/CompanyCompliance/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/CompanyCompliance/form",
    Component: React.lazy(
      () => import("../../Pages/Master/ComplianceMaster/CompanyCompliance/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/compliance-master/CompanyCompliance/Reviewform",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/ComplianceMaster/CompanyCompliance/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // sales-invoice
  {
    path: "/sales/sales-invoice",
    Component: React.lazy(() => import("../../Pages/Sales/SalesInvoice")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-invoice/site-cost",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesInvoice/siteCost")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-invoice/other-charges",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesInvoice/otherCharges")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-invoice/detail",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesInvoice/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-invoice/editForm",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesInvoice/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Accounting
  {
    path: "/sales/sales-accounting",
    Component: React.lazy(() => import("../../Pages/Sales/SalesAccounting")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-accounting/detail",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesAccounting/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/gst-calendar",
    Component: React.lazy(() => import("../../Pages/Reports/GstCalendar")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/hr-calendar",
    Component: React.lazy(() => import("../../Pages/Reports/HrCalendar")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/itr-calendar",
    Component: React.lazy(() => import("../../Pages/Reports/ItrCalendar")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/tds-calendar",
    Component: React.lazy(() => import("../../Pages/Reports/TdsCalendar")),
    exact: true,
    isNavbar: true
  },
  // QC Inspection
  {
    path: "/reports/qc-inspection",
    Component: React.lazy(() => import("../../Pages/Reports/QcInspection")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/qc-inspection/inspection-review",
    Component: React.lazy(
      () => import("../../Pages/Reports/QcInspection/Inspection")
    ),
    exact: true,
    isNavbar: true
  },

  // Qc Obervation
  {
    path: "/reports/qc-observation",
    Component: React.lazy(() => import("../../Pages/Reports/QcObservation")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/reports/qc-observation/observation-review",
    Component: React.lazy(
      () => import("../../Pages/Reports/QcObservation/Observation.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Qc Walk Through
  {
    path: "/reports/qc-walk-through",
    Component: React.lazy(() => import("../../Pages/Reports/QcWalkThrough")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/qc-walk-through/walkthrough-review",
    Component: React.lazy(
      () => import("../../Pages/Reports/QcWalkThrough/WalkThrough.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //QC Training
  {
    path: "/reports/qc-training",
    Component: React.lazy(() => import("../../Pages/Reports/QcTraining")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/qc-training/training-review",
    Component: React.lazy(
      () => import("../../Pages/Reports/QcTraining/Training.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // clp start
  //ConstructionLinkPayment (CLP Milestone)
  {
    path: "/crm-master/clp-milestone",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ClpMilestone/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/clp-milestone/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ClpMilestone/Form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/clp-milestone/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ClpMilestone/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-plan",
    Component: React.lazy(() => import("../../Pages/CRM/ProjectClpPlan")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-plan/add",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpPlan/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-plan/details",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpPlan/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-plan/edit",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpPlan/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-plan/edit-milestone",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpPlan/editMilestone.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //clp payment schedule
  {
    path: "/crm/payment-schedule",
    Component: React.lazy(() => import("../../Pages/CRM/ClpPaymentSchedule")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-schedule/add",
    Component: React.lazy(
      () => import("../../Pages/CRM/ClpPaymentSchedule/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-schedule/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/CRM/ClpPaymentSchedule/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-schedule/selectItem",
    Component: React.lazy(
      () => import("../../Pages/CRM/ClpPaymentSchedule/selectItem.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // clp demand
  {
    path: "/crm/project-clp-demand",
    Component: React.lazy(() => import("../../Pages/CRM/ProjectClpDemand")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-demand/add",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpDemand/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/project-clp-demand/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpDemand/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-demand/selectItem",
    Component: React.lazy(
      () => import("../../Pages/CRM/ProjectClpDemand/selectItem.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // clp end
  // Customer Ticket
  {
    path: "/crm/customer-ticket",
    Component: React.lazy(() => import("../../Pages/CRM/CustomerTicket")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/customer-ticket/new",
    Component: React.lazy(() => import("../../Pages/CRM/CustomerTicket/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/customer-ticket/edit",
    Component: React.lazy(() => import("../../Pages/CRM/CustomerTicket/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/customer-ticket/view",
    Component: React.lazy(
      () => import("../../Pages/CRM/CustomerTicket/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/customer-ticket/addtask",
    Component: React.lazy(
      () => import("../../Pages/CRM/CustomerTicket/addtask")
    ),
    exact: true,
    isNavbar: true
  },
  // Ticket
  {
    path: "/admin/ticket",
    Component: React.lazy(() => import("../../Pages/Admin/Ticket")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/ticket/new",
    Component: React.lazy(() => import("../../Pages/Admin/Ticket/form.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/ticket/details",
    Component: React.lazy(
      () => import("../../Pages/Admin/Ticket/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/ticket/edit",
    Component: React.lazy(() => import("../../Pages/Admin/Ticket/edit.jsx")),
    exact: true,
    isNavbar: true
  },
  //Customer EOI
  {
    path: "/sales/customer-eoi",
    Component: React.lazy(() => import("../../Pages/Sales/CustomerEOI")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/customer-eoi/form",
    Component: React.lazy(() => import("../../Pages/Sales/CustomerEOI/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/customer-eoi/review-form",
    Component: React.lazy(
      () => import("../../Pages/Sales/CustomerEOI/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/customer-eoi/edit",
    Component: React.lazy(() => import("../../Pages/Sales/CustomerEOI/edit")),
    exact: true,
    isNavbar: true
  },
  //User
  {
    path: "/hr/userList",
    Component: React.lazy(() => import("../../Pages/HR/User")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/hr/userList/form",
    Component: React.lazy(() => import("../../Pages/HR/User/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/userList/edit-form",
    Component: React.lazy(() => import("../../Pages/HR/User/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/userList/review-form",
    Component: React.lazy(() => import("../../Pages/HR/User/ReviewForm")),
    exact: true,
    isNavbar: true
  },
  //  Training  - Schedule//
  {
    path: "/admin/training-schedule",
    Component: React.lazy(() => import("../../Pages/Admin/Training")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/training-schedule/add",
    Component: React.lazy(() => import("../../Pages/Admin/Training/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/training-schedule/edit",
    Component: React.lazy(() => import("../../Pages/Admin/Training/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/training-schedule/review",
    Component: React.lazy(
      () => import("../../Pages/Admin/Training/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },

  // Admin Training //
  {
    path: "/admin/admin-training",
    Component: React.lazy(() => import("../../Pages/Admin/AdminTraining")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/admin-training/training-details",
    Component: React.lazy(
      () => import("../../Pages/Admin/AdminTraining/trainingDetails")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/admin-training/add",
    Component: React.lazy(() => import("../../Pages/Admin/AdminTraining/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/admin-training/edit",
    Component: React.lazy(() => import("../../Pages/Admin/AdminTraining/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/admin-training/view",
    Component: React.lazy(
      () => import("../../Pages/Admin/AdminTraining/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/admin-training/approval",
    Component: React.lazy(
      () => import("../../Pages/Admin/AdminTraining/approval")
    ),
    exact: true,
    isNavbar: true
  },
  // CustomerTicketCategory
  {
    path: "/crm-master/customer-ticket-category",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerTicketCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-ticket-category/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/CustomerTicketCategory/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-ticket-category/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/CustomerTicketCategory/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // SalesPlan
  {
    path: "/sales-master/sales-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/add",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/details",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/edit-sales-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan/editSalesPlan.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/create-sales-marketing-plan",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/SalesMaster/SalesPlan/createMarketing.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-plan/edit-sales-marketing-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesPlan/editMarketing")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/Service-Bill",
    Component: React.lazy(() => import("../../Pages/Accounts/ServiceFuelBill")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/account/Service-Bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ServiceFuelBill/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/Service-Bill/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ServiceFuelBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Marketing Expense
  {
    path: "/marketing/marketing-expense",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingExpense/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-expense/request",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingExpense/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-expense/detail",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingExpense/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-expense/editForm",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingExpense/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-expense/updateForm",
    Component: React.lazy(
      () =>
        import("../../Pages/Marketing/MarketingExpense/marketingInvoiceUpdateForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Pre Sales Travel
  {
    path: "/admin/travel-completed",
    Component: React.lazy(
      () => import("../../Pages/CRM/TravelCompleted/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/admin/travel-completed/billpay",
    Component: React.lazy(
      () => import("../../Pages/CRM/TravelCompleted/siteVisitBillPay.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/admin/travel-bill",
    Component: React.lazy(() => import("../../Pages/Accounts/TravelBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/travel-bill/review",
    Component: React.lazy(
      () => import("../../Pages/Accounts/TravelBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/travel-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/TravelBill/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //---Loan----
  {
    path: "/accounts-master/loan-category",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/LoanCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/loan-category/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/LoanCategory/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/loan-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/LoanCategory/EditForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/loan-security",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/LoanSecurity")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/loan-security/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/LoanSecurity/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan",
    Component: React.lazy(() => import("../../Pages/Accounts/Loan")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan/add",
    Component: React.lazy(() => import("../../Pages/Accounts/Loan/form.jsx")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan/reviewform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/Loan/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/loan/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/Loan/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Accounts Loan
  {
    path: "/accounts/loan/applied-edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/Loan/appliedForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/penalty-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/PenaltyReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/penalty-reason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/PenaltyReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/penalty-reason/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/AccountMaster/PenaltyReason/EditForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Routes Vishal
  // Asset Insurance Type
  {
    path: "/asset/asset-insuranceType",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetInsuranceType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-insuranceType/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetInsuranceType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-insuranceType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetInsuranceType/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Asset License Type

  {
    path: "/asset/asset-licenseType",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicenseType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-licenseType/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicenseType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-licenseType/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicenseType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // License
  {
    path: "/asset/master-license",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicense")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/master-license/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicense/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/master-license/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetLicense/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Asset Make
  {
    path: "/asset/asset-make",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetMake")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-make/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetMake/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-make/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetMake/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Asset Model
  {
    path: "/asset/asset-model",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetModel")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-model/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetModel/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-model/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetModel/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Group
  {
    path: "/asset/asset-group",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetGroup")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-group/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetGroup/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-group/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetGroup/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Category
  {
    path: "/asset/asset-category",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetCategory")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-category/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/AssetCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Specification
  {
    path: "/asset/asset-specification",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/Specification/")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/Specification/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/Specification/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Specification Value
  {
    path: "/asset/asset-specification-value",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/SpecificationValue")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification-value/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/SpecificationValue/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification-value/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/SpecificationValue/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Specification Value Set
  {
    path: "/asset/asset-specification-value-set",
    Component: React.lazy(
      () => import("../../Pages/Master/AssestsMaster/SpecificationValueSet")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification-value-set/add",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/AssestsMaster/SpecificationValueSet/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-specification-value-set/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/AssestsMaster/SpecificationValueSet/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Transfer
  {
    path: "/asset/asset-transfer",
    Component: React.lazy(() => import("../../Pages/Assests/AssetTransfer")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-transfer/add",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetTransfer/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-transfer/edit",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetTransfer/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-transfer/view",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetTransfer/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-transfer/request",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetTransfer/assetTransferRequest")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Insurance
  {
    path: "/asset/asset-insurance",
    Component: React.lazy(() => import("../../Pages/Assests/AssetInsurance")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-insurance/add",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetInsurance/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-insurance/edit",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetInsurance/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-insurance/view",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetInsurance/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset License
  {
    path: "/asset/asset-license",
    Component: React.lazy(() => import("../../Pages/Assests/AssetLicense")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-license/add",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetLicense/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-license/edit",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetLicense/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-license/view",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetLicense/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Asset Maintenance
  {
    path: "/asset/asset-mainteance",
    Component: React.lazy(() => import("../../Pages/Assests/AssetMaintenance")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-mainteance/add",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetMaintenance/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-mainteance/edit",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetMaintenance/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/asset-mainteance/view",
    Component: React.lazy(
      () => import("../../Pages/Assests/AssetMaintenance/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Assets
  {
    path: "/asset/assests",
    Component: React.lazy(() => import("../../Pages/Assests/Assests")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/assests/form",
    Component: React.lazy(() => import("../../Pages/Assests/Assests/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/assests/edit",
    Component: React.lazy(() => import("../../Pages/Assests/Assests/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/asset/assests/view",
    Component: React.lazy(
      () => import("../../Pages/Assests/Assests/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Referral
  {
    path: "/sales/sales-referral",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral/Reviewform",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral/billPay",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/salesReferralPay")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral-settlement",
    Component: React.lazy(() => import("../../Pages/Sales/SalesReferral/form")),
    exact: true,
    isNavbar: true
  },
  // cheque usags
  {
    path: "/account/cheque-usage",
    Component: React.lazy(() => import("../../Pages/Accounts/ChequeUsage")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account/cheque-usage-review",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ChequeUsage/chequeReview.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Commission
  {
    path: "/sales/sales-consultant",
    Component: React.lazy(() => import("../../Pages/Sales/SalesCommission")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-consultant/form",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesCommission/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-consultant/Reviewform",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesCommission/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Audit Masters(SVM)

  //---------------------------------- Department Process master(Svm)----------------------------
  {
    path: "/audit-master/department-process",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/Process")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/department-process/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/Process/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/department-process/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/Process/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/department-process/reviewform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/Process/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // ---------------Audit Process Documents(svm)-----------------------
  {
    path: "/audit-master/process-documents",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessDocument")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/process-documents/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessDocument/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/process-documents/reviewform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessDocument/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/process-documents/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessDocument/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Audit CheckPoint Option
  {
    path: "/audit-master/checkpoint-option",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCheckPointOption")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/checkpoint-option/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCheckPointOption/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/checkpoint-option/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCheckPointOption/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Audit Process CheckPoint
  {
    path: "/audit-master/process-checkpoint",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessCheckPoint")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/process-checkpoint/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessCheckPoint/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/process-checkpoint/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/ProcessCheckPoint/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // Audit Schedule(Svm)

  {
    path: "/audit/audit-schedule",
    Component: React.lazy(() => import("../../Pages/Audit/AuditSchedule")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/add",
    Component: React.lazy(() => import("../../Pages/Audit/AuditSchedule/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/edit",
    Component: React.lazy(
      () => import("../../Pages/Audit/AuditSchedule/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/review-form",
    Component: React.lazy(
      () => import("../../Pages/Audit/AuditSchedule/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/details",
    Component: React.lazy(
      () => import("../../Pages/Audit/AuditSchedule/Review.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/preview",
    Component: React.lazy(
      () => import("../../Pages/Audit/AuditSchedule/previewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit/audit-schedule/question-form",
    Component: React.lazy(
      () => import("../../Pages/Audit/AuditSchedule/questionForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Invontory Site Summary ORM
  {
    path: "/orm/inventory-site",
    Component: React.lazy(
      () => import("../../Pages/ORM/InventorySiteORM/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  // Invontory Land Summary ORM
  {
    path: "/orm/inventory-land",
    Component: React.lazy(
      () => import("../../Pages/ORM/InventoryLandORM/index")
    ),
    exact: true,
    isNavbar: true
  },
  // Travel Plaining
  {
    path: "/hr/travel-planning",
    Component: React.lazy(() => import("../../Pages/HR/TravelPlanning")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/travel-planning/form",
    Component: React.lazy(() => import("../../Pages/HR/TravelPlanning/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/travel-planning/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/HR/TravelPlanning/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/travel-planning/editForm",
    Component: React.lazy(
      () => import("../../Pages/HR/TravelPlanning/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/salary-structure",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryStructure")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/salary-structure/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryStructure/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/salary-structure/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryStructure/formEdit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/salary-structure/review",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/SalaryStructure/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  // HR Employee Details
  {
    path: "/hr/hr-employee",
    Component: React.lazy(() => import("../../Pages/HR/HrEmployee")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/hr-employee/create",
    Component: React.lazy(() => import("../../Pages/HR/HrEmployee/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/hr-employee/add-details",
    Component: React.lazy(() => import("../../Pages/HR/HrEmployee/addDetails")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/hr-employee/review",
    Component: React.lazy(() => import("../../Pages/HR/HrEmployee/ReviewForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/hr-employee/edit",
    Component: React.lazy(() => import("../../Pages/HR/HrEmployee/editForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/user-check-In",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserCheckin")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/user-check-In/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserCheckin/form")
    ),
    exact: true,
    isNavbar: true
  },
  // Accounts Master Tds Section
  {
    path: "/accounts-master/tds-section",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/TdsSection")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/tds-section/add",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/TdsSection/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/tds-section/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/TdsSection/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/tds-section/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/TdsSection/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // DEDUCTION
  {
    path: "/account/tds-deduction/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Accounts/TdsDeduction/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  // Liaison Process Plan Owner Assign
  {
    path: "/business-development/liaison_process_plan_owner_assign",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlanOwnerAssign")
    ),
    exact: true,
    isNavbar: true
  },
  // Liaison Process Plan Accountability
  {
    path: "/business-development/liaison_process_plan_accountable",
    Component: React.lazy(
      () =>
        import("../../Pages/BusinessDevelopment/LiaisonProcessPlanAccountable")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/live-booking",
    Component: React.lazy(() => import("../../Pages/Sales/LiveBookingForm")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/live-booking/form",
    Component: React.lazy(
      () => import("../../Pages/Sales/LiveBookingForm/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/live-booking/review",
    Component: React.lazy(
      () => import("../../Pages/Sales/LiveBookingForm/Review")
    ),
    exact: true,
    isNavbar: true
  },
  //QC Stages Map (Master)
  {
    path: "/qc/qc-activity-stage-map",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-activity-stage-map-add",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-activity-stage-map-update",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/live-booking/form/:uniqueSiteID",
    Component: React.lazy(
      () => import("../../Pages/Share/LiveBookingShare/form")
    ),
    exact: true,
    isNavbar: false
  },
  //QC Stages Map (Master)
  {
    path: "/qc/qc-activity-stage-map",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-activity-stage-map-add",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/qc/qc-activity-stage-map-update",
    Component: React.lazy(
      () => import("../../Pages/Master/QCMaster/QcStageMap/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Referral
  {
    path: "/sales/sales-referral",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral/Reviewform",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral/billPay",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferral/salesReferralPay")
    ),
    exact: true,
    isNavbar: true
  },
  //Sales Referral Bill
  {
    path: "/sales/sales-referral-bill",
    Component: React.lazy(() => import("../../Pages/Sales/SalesReferralBill")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral-bill/review",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferralBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReferralBill/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //CRM Masters
  //project peremium cost
  {
    path: "/crm-master/project-premium-cost",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectPremiumCost")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/project-premium-cost/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectPremiumCost/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/project-premium-cost/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectPremiumCost/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //Readiness Checklist
  {
    path: "/crm-master/readiness-checklist",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReadinessChecklist")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/readiness-checklist/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReadinessChecklist/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/readiness-checklist/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReadinessChecklist/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //CRM Site Investor
  {
    path: "/crm-master/investor",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteInvestor/")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/investor/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteInvestor/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/investor/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteInvestor/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM DelayReason
  {
    path: "/crm-master/delayreason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/DelayReason")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/delayreason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/DelayReason/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/delayreason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/DelayReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // site-tds
  {
    path: "/crm-master/site-tds",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteTDS/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-tds",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteTDS/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-tds/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteTDS/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-tds/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteTDS/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-tds/review",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteTDS/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Crm Lead Category
  {
    path: "/crm-master/lead-category",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadCategory/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-category/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadCategory/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadCategory/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //Crm  Lead Constraint

  {
    path: "/crm-master/lead-constraint",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadConstraint/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-constraint/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadConstraint/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-constraint/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadConstraint/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Project Site Cost
  {
    path: "/crm-master/project-site-cost",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmProjectSiteCost")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-site-cost/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmProjectSiteCost/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Project Registration Cost
  {
    path: "/crm-master/project-registration-cost",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmProjectRegistrationCost")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-registration-cost/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/CrmProjectRegistrationCost/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-registration-cost/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/CrmProjectRegistrationCost/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM Source Category
  {
    path: "/crm-master/source-category",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SourceCategory/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/source-category/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SourceCategory/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/source-category/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SourceCategory/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Source
  {
    path: "/crm-master/source",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Source/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/source/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Source/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/source/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Source/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Sub Source
  {
    path: "/crm-master/sub-source",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SubSource/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/sub-source/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SubSource/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/sub-source/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SubSource/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Reason

  {
    path: "/crm-master/reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Reason/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/reason/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Reason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Reason/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Dimension

  {
    path: "/crm-master/dimension",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Dimension")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/dimension/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Dimension/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/dimension/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/Dimension/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Site Face
  {
    path: "/crm-master/site-face",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteFace")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-face/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteFace/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-face/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteFace/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Site Premium type
  {
    path: "/crm-master/site-premium-type",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SitePremiumType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-premium-type/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SitePremiumType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-premium-type/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SitePremiumType/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Lead Status
  {
    path: "/crm-master/lead-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadStatus")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/lead-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/LeadStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Release Status
  {
    path: "/crm-master/release-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReleaseStatus")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/release-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReleaseStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/release-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ReleaseStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Site Status
  {
    path: "/crm-master/site-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteStatus/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/site-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/SiteStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM Cancellation Reason
  {
    path: "/crm-master/cancellation-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CancellationReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/cancellation-reason/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CancellationReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/cancellation-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CancellationReason/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Block Reason
  {
    path: "/crm-master/crm-block-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BlockReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-block-reason/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BlockReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-block-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BlockReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM Other Charges
  {
    path: "/crm-master/crm-other-charges",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/OtherCharges")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-other-charges/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/OtherCharges/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-other-charges/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/OtherCharges/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM Project Other Charge Map
  {
    path: "/crm-master/crm-project-other-charge-map",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectOtherChargesMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-project-other-charge-map/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectOtherChargesMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-project-other-charge-map/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectOtherChargesMap/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-project-other-charge-map/reviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/ProjectOtherChargesMap/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM  Master Call Status
  {
    path: "/crm-master/crm-call-status",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CallStatus")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-call-status/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CallStatus/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-call-status/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CallStatus/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // CRM  Master Unqaulified Reason
  {
    path: "/crm-master/crm-unqualified-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/UnqualifiedReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-unqualified-reason/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/UnqualifiedReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-unqualified-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/UnqualifiedReason/edit")
    ),
    exact: true,
    isNavbar: true
  },

  // CRM Project Discount
  {
    path: "/crm-master/crm-project-disocunt",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectDiscount/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-project-discount/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectDiscount/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-project-discount/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectDiscount/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //Marketing Campaign
  {
    path: "/marketing/marketing-campaign",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingCampaign")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-campaign/request",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingCampaign/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-campaign/detail",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingCampaign/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/marketing/marketing-campaign/editForm",
    Component: React.lazy(
      () => import("../../Pages/Marketing/MarketingCampaign/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Module Requriments
  {
    path: "/admin/module-requirements",
    Component: React.lazy(() => import("../../Pages/Admin/ModuleRequirement")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/module-requirements/add",
    Component: React.lazy(
      () => import("../../Pages/Admin/ModuleRequirement/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/module-requirements/edit",
    Component: React.lazy(
      () => import("../../Pages/Admin/ModuleRequirement/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/admin/module-requirements/view",
    Component: React.lazy(
      () => import("../../Pages/Admin/ModuleRequirement/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  // Sales Order
  {
    path: "/sales/sales-order",
    Component: React.lazy(() => import("../../Pages/Sales/SalesOrder")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-order/form",
    Component: React.lazy(() => import("../../Pages/Sales/SalesOrder/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-order/review",
    Component: React.lazy(() => import("../../Pages/Sales/SalesOrder/Review")),
    exact: true,
    isNavbar: true
  },
  //Rent Bill
  {
    path: "/accounts/lease/rentBillPay",
    Component: React.lazy(
      () => import("../../Pages/Accounts/Lease/rentBillPay")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rent-bill",
    Component: React.lazy(() => import("../../Pages/Accounts/RentBill/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rent-bill/review",
    Component: React.lazy(
      () => import("../../Pages/Accounts/RentBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/rent-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/RentBill/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //consultantFees
  {
    path: "/accounts/projectConsultantFees",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantFees")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/projectConsultantFees/add",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantFees/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/projectConsultantFees/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantFees/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/projectConsultantFees/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantFees/editForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/projectConsultantFees/billPay",
    Component: React.lazy(
      () =>
        import("../../Pages/Accounts/ProjectConsultantFees/consultantFessbillpay")
    ),
    exact: true,
    isNavbar: true
  },

  // land consultant bill pay
  {
    path: "/accounts/project-consultant-bill",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantBill")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-consultant-bill/review",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/project-consultant-bill/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/ProjectConsultantBill/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Project Progress For Customer
  {
    path: "/crm-master/project-progress-for-customer",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/ProjectProgressForCustomer")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-progress-for-customer/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/ProjectProgressForCustomer/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-progress-for-customer/review",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/ProjectProgressForCustomer/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/project-progress-for-customer/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/ProjectProgressForCustomer/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Cheque Template
  {
    path: "/accounts-master/cheque-template",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/cheque-template/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/cheque-template/review",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts-master/cheque-template/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //  Customer Contact Type
  {
    path: "/crm-master/customer-contact-type",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContactType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-contact-type/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContactType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-contact-type/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContactType/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //  Customer Contact Type
  {
    path: "/crm-master/customer-contact",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContact")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-contact/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContact/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/customer-contact/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerContact/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Customer Feedback
  {
    path: "/crm-master/customer-feedback",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerFeedback")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/customer-feedback/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CustomerFeedback/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Cheque Template
  {
    path: "/account-masters/cheque-template",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-masters/cheque-template/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-masters/cheque-template/review",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-masters/cheque-template/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/ChequeTemplate/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // employee shift
  {
    path: "/hr/employee-shift-map",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeShiftMap")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/employee-shift-map/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeShiftMap/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/employee-shift-map/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeShiftMap/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //attendance location
  //   {
  //   path: "/HR/EmployeeCheckin",
  //   Component: React.lazy(() => import("../../Pages/HR/EmployeeCheckin")),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/HR/EmployeeCheckin/Maps",
  //   Component: React.lazy(
  //     () => import("../../Pages/HR/EmployeeCheckin/googleMaps")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/hr/employee-checkin",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/HRMaster/EmployeeCheckin")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/hr/employee-checkin/add",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/HRMaster/EmployeeCheckin/form")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  // {
  //   path: "/hr/employee-checkin/edit",
  //   Component: React.lazy(
  //     () => import("../../Pages/Master/HRMaster/EmployeeCheckin/edit")
  //   ),
  //   exact: true,
  //   isNavbar: true
  // },
  {
    path: "/hr/attendance-location",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeCheckin")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-location/add",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeCheckin/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-location/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/EmployeeCheckin/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //attendance location permission
  {
    path: "/hr/attendance-location-permission",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/AttendanceLocationPermission")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-location-permission/add",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/AttendanceLocationPermission/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-location-permission/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/AttendanceLocationPermission/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-location-permission/reviewForm",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/AttendanceLocationPermission/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // overtime attendance
  {
    path: "/hr/overtime-attendance",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeAttendance")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/overtime-attendance/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeAttendance/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/overtime-attendance/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeAttendance/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/overtime-applicability",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeApplicability")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/overtime-applicability/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeApplicability/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/overtime-applicability/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/OvertimeApplicability/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/field-location-applicability",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/FieldLocationApplicability")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/field-location-applicability/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/FieldLocationApplicability/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/field-location-applicability/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/HRMaster/FieldLocationApplicability/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/role",
    Component: React.lazy(() => import("../../Pages/Master/HRMaster/UserRole")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/role/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserRole/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/role/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/UserRole/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //location
  {
    path: "/hr-master/location",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/HrLocation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/location/form",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/HrLocation/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr-master/location/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/HRMaster/HrLocation/edit")
    ),
    exact: true,
    isNavbar: true
  },

  //Customer Ledger
  {
    path: "/accounts/customer-ledger",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CustomerLedger/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/customer-ledger/form",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CustomerLedger/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/customer-ledger/paid-amount",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CustomerLedger/PaidAmount")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/customer-ledger/payment-payable",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CustomerLedger/PaymentPayable")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/customer-ledger/details",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CustomerLedger/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  //Company Resolution
  {
    path: "/crm/company-resolution",
    Component: React.lazy(() => import("../../Pages/CRM/CompanyResolution")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/company-resolution/request",
    Component: React.lazy(
      () => import("../../Pages/CRM/CompanyResolution/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/company-resolution/detail",
    Component: React.lazy(
      () => import("../../Pages/CRM/CompanyResolution/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/company-resolution/editForm",
    Component: React.lazy(
      () => import("../../Pages/CRM/CompanyResolution/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //site authority
  {
    path: "/crm/site-authority",
    Component: React.lazy(() => import("../../Pages/CRM/SiteAuthority")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/site-authority/request",
    Component: React.lazy(() => import("../../Pages/CRM/SiteAuthority/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/site-authority/detail",
    Component: React.lazy(
      () => import("../../Pages/CRM/SiteAuthority/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-regularization",
    Component: React.lazy(
      () => import("../../Pages/HR/AttendanceRegularization")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-regularization/create",
    Component: React.lazy(
      () => import("../../Pages/HR/AttendanceRegularization/Form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/hr/attendance-regularization/details",
    Component: React.lazy(
      () => import("../../Pages/HR/AttendanceRegularization/Details")
    ),
    exact: true,
    isNavbar: true
  },
  //Mortgage NOC
  {
    path: "/crm/mortgage-noc",
    Component: React.lazy(() => import("../../Pages/CRM/MortgageNoc")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/mortgage-noc/review",
    Component: React.lazy(
      () => import("../../Pages/CRM/MortgageNoc/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Payment NOC
  {
    path: "/crm/payment-noc",
    Component: React.lazy(() => import("../../Pages/CRM/PaymentNoc")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-noc/Review",
    Component: React.lazy(
      () => import("../../Pages/CRM/PaymentNoc/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Legal File Request
  {
    path: "/crm/legal-file-request",
    Component: React.lazy(
      () => import("../../Pages/CRM/LegalFileRequest/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/legal-file-request/review",
    Component: React.lazy(
      () => import("../../Pages/CRM/LegalFileRequest/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //sales cancellation
  {
    path: "/sales/sales-cancellation",
    Component: React.lazy(() => import("../../Pages/Sales/SalesCancellation")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/sales/sales-cancellation/detail",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesCancellation/Reviewform")
    ),
    exact: true,
    isNavbar: true
  },
  //Purchase Return
  {
    path: "/sales/sales-return",
    Component: React.lazy(() => import("../../Pages/Sales/SalesReturn")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-return/form",
    Component: React.lazy(() => import("../../Pages/Sales/SalesReturn/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-return/detail",
    Component: React.lazy(() => import("../../Pages/Sales/SalesReturn/detail")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-return/editForm",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReturn/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-return/pending",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReturn/pending")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-return/approve",
    Component: React.lazy(
      () => import("../../Pages/Sales/SalesReturn/approved")
    ),
    exact: true,
    isNavbar: true
  },
  // sales return (Credit Note)
  {
    path: "/accounts/credit-note",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CreditNote/index.jsx")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/credit-note/detail",
    Component: React.lazy(
      () => import("../../Pages/Accounts/CreditNote/Reviewform.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //Purchase Return Accounts
  {
    path: "/procurement/purchase-return-account",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturnAccounts")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/procurement/purchase-return-account/detail",
    Component: React.lazy(
      () => import("../../Pages/Procurement/PurchaseReturnAccounts/detail")
    ),
    exact: true,
    isNavbar: true
  },
  //Crm Booking Report
  {
    path: "/crm/booking",
    Component: React.lazy(() => import("../../Pages/Reports/BookingReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/booking/details",
    Component: React.lazy(
      () => import("../../Pages/Reports/BookingReport/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //project performance report

  {
    path: "/report/project-performance-report",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProjectPerformanceReport/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-call",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualFollowUp")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/planned-site-visit",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/PlannedSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/planned-call",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProjectPerformanceReport/PlannedCall")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-site-visit",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualSiteVisit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/prospective-client",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/cancellation",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/TotalCancellation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/cancellation-previous",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/CancellationPrevious")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/booking",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/TotalBooking.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/gross-sales",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualGrossSales")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/hot-prospective-client",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/HotProspectiveClient")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/planned-cp-meeting",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/PlannedCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-cp-meeting",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualCPMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/planned-client-meeting",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/PlannedClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-client-meeting",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualClientMeeting")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/enquiry-follow-up",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/EnquiryFollowUp")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-agreement",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualAgreement")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/actual-registration",
    Component: React.lazy(
      () =>
        import("../../Pages/Reports/ProjectPerformanceReport/ActualRegistration")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/project-performance-report/total-leads",
    Component: React.lazy(
      () => import("../../Pages/Reports/ProjectPerformanceReport/totalLeads")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/report/sales-review-report/totalLead",
    Component: React.lazy(
      () => import("../../Pages/Reports/SalesReviewReport/totalLeads")
    ),
    exact: true,
    isNavbar: true
  },
  // Payment Receipt Tally Info
  {
    path: "/crm-master/payment-tally-info",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/PaymentReceiptTallyInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/payment-tally-info/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/PaymentReceiptTallyInfo/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/payment-tally-info/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/PaymentReceiptTallyInfo/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Bank Receipt Tally Info
  {
    path: "/crm-master/bank-tally-info",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BankTallyInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/bank-tally-info/add",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BankTallyInfo/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/bank-tally-info/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/BankTallyInfo/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //account type
  {
    path: "/account-master/account-type",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/AccountType")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/account-type/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/AccountType/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/account-type/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/AccountType/EditForm")
    ),
    exact: true,
    isNavbar: true
  },
  //First Party Katha Transfer
  {
    path: "/crm/first-party-katha-transfer",
    Component: React.lazy(
      () => import("../../Pages/CRM/FirstPartyKathaTransfer")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/first-party-katha-transfer/Review",
    Component: React.lazy(
      () => import("../../Pages/CRM/FirstPartyKathaTransfer/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // EC Request
  {
    path: "/crm/ec-request",
    Component: React.lazy(() => import("../../Pages/CRM/ECRequest/index")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/ec-request/review",
    Component: React.lazy(() => import("../../Pages/CRM/ECRequest/ReviewForm")),
    exact: true,
    isNavbar: true
  },
  //Stone Marking
  {
    path: "/crm/stone-marking",
    Component: React.lazy(() => import("../../Pages/CRM/StoneMarking")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/stone-marking/Review",
    Component: React.lazy(
      () => import("../../Pages/CRM/StoneMarking/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Stamp Duty Vishal
  {
    path: "/crm/stamp-duty",
    Component: React.lazy(() => import("../../Pages/CRM/StampDuty")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/stamp-duty/Review",
    Component: React.lazy(() => import("../../Pages/CRM/StampDuty/ReviewForm")),
    exact: true,
    isNavbar: true
  },
  //E Stamp Bill
  {
    path: "/crm/e-stamp-bill",
    Component: React.lazy(() => import("../../Pages/CRM/EStampBill")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/e-stamp-bill/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/CRM/EStampBill/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/e-stamp-bill/edit",
    Component: React.lazy(() => import("../../Pages/CRM/EStampBill/editForm")),
    exact: true,
    isNavbar: true
  },
  // Price Negotation
  {
    path: "/crm/price-negotiation",
    Component: React.lazy(() => import("../../Pages/CRM/PriceNegotiation")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/price-negotiation/details",
    Component: React.lazy(
      () => import("../../Pages/CRM/PriceNegotiation/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Payment FollowUp
  {
    path: "/crm/payment-followup",
    Component: React.lazy(() => import("../../Pages/CRM/PaymentFollowUp")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/payment-followup-details",
    Component: React.lazy(
      () => import("../../Pages/CRM/PaymentFollowUp/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/not-realization-reason",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/AccountMaster/NotRealizationReason/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/not-realization-reason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/NotRealizationReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/account-master/not-realization-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/NotRealizationReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //Project Plan Approval Reason
  {
    path: "/bd-masters/project-plan-approval-reason",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPlanApprovalReason")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/project-plan-approval-reason/form",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPlanApprovalReason/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/bd-masters/project-plan-approval-reason/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/BDMaster/ProjectPlanApprovalReason/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Sales Incentive Plan
  {
    path: "/sales-master/sales-incentive-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesIncentivePlan/index")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-incentive-plan/form",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesIncentivePlan/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-incentive-plan/review",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/SalesMaster/SalesIncentivePlan/reviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales-master/sales-incentive-plan/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesIncentivePlan/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Presales Incentive Plan
  {
    path: "/presales-master/presales-incentive-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/PreSalesMaster/PreSalesIncentivePlan")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/presales-master/presales-incentive-plan/form",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/PreSalesMaster/PreSalesIncentivePlan/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/presales-master/presales-incentive-plan/review",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/PreSalesMaster/PreSalesIncentivePlan/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/presales-master/presales-incentive-plan/edit",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/PreSalesMaster/PreSalesIncentivePlan/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  //CRM Incentive Plan
  {
    path: "/crm-master/crm-incentive-plan",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmIncentivePlan")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/crm-incentive-plan/review",
    Component: React.lazy(
      () =>
        import("../../Pages/Master/CrmMaster/CrmIncentivePlan/ReviewForm.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-incentive-plan/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmIncentivePlan/edit.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/crm-incentive-plan/new",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/CrmIncentivePlan/form.jsx")
    ),
    exact: true,
    isNavbar: true
  },
  // Audit Schedul(integration)
  {
    path: "/audit-master/audit-calendar",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCalendar")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/audit-calendar/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCalendar/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/audit-calendar/editform",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditCalendar/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Audit Observation
  {
    path: "/audit-master/audit-observation",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditObservation")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/audit-observation/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditObservation/edit")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/audit-master/audit-observation/reviewForm",
    Component: React.lazy(
      () => import("../../Pages/Master/AuditMaster/AuditObservation/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  // Sales Referal Slabs
  {
    path: "/sales/sales-referral-slab",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesRefSlab")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral-slab/form",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesRefSlab/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/sales/sales-referral-slab/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/SalesMaster/SalesRefSlab/edit")
    ),
    exact: true,
    isNavbar: true
  },
  //Booking Draft Request
  {
    path: "/crm/draft-request",
    Component: React.lazy(() => import("../../Pages/CRM/DraftRequest")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/draft-request/details",
    Component: React.lazy(
      () => import("../../Pages/CRM/DraftRequest/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  //BRS Info
  {
    path: "/accounts-master/brs-account",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/BRSInfo")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts-master/brs-account/form",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/BRSInfo/form")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts-master/brs-account/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/AccountMaster/BRSInfo/EditForm")
    ),
    exact: true,
    isNavbar: true
  },

  //brs report
  {
    path: "/accounts/brs-report",
    Component: React.lazy(() => import("../../Pages/Accounts/BRSReport")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/brs-report/form",
    Component: React.lazy(() => import("../../Pages/Accounts/BRSReport/form")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/accounts/brs-report/Reviewform",
    Component: React.lazy(
      () => import("../../Pages/Accounts/BRSReport/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/accounts/brs-report/edit",
    Component: React.lazy(
      () => import("../../Pages/Accounts/BRSReport/editForm")
    ),
    exact: true,
    isNavbar: true
  },
  //Inventory
  {
    path: "/crm/inventory",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/inventory/site",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory/Site")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/detail",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory/ReviewForm")),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm/inventory/edit",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory/edit")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/releaseStatus",
    Component: React.lazy(
      () => import("../../Pages/CRM/Inventory/ReleaseStatus")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/mortageInfo",
    Component: React.lazy(
      () => import("../../Pages/CRM/Inventory/MortageInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/form",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory/form")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/investorInfo",
    Component: React.lazy(
      () => import("../../Pages/CRM/Inventory/investorInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/premiumTypeInfo",
    Component: React.lazy(
      () => import("../../Pages/CRM/Inventory/PremiumTypeInfo")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory/survey-no",
    Component: React.lazy(() => import("../../Pages/CRM/Inventory/Surveyno")),
    exact: true,
    isNavbar: true
  },
  // Inventory Blocked
  {
    path: "/crm/inventory-blocked",
    Component: React.lazy(() => import("../../Pages/CRM/InventoryBlocked")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory-blocked/add",
    Component: React.lazy(
      () => import("../../Pages/CRM/InventoryBlocked/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory-blocked/Details",
    Component: React.lazy(
      () => import("../../Pages/CRM/InventoryBlocked/reviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory-blocked/un-blocked",
    Component: React.lazy(
      () => import("../../Pages/CRM/InventoryBlocked/inventoryUnBlock")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm/inventory-blocked/edit",
    Component: React.lazy(
      () => import("../../Pages/CRM/InventoryBlocked/edit")
    ),
    exact: true,
    isNavbar: true
  },
  // Audit Report
  {
    path: "/reports/audit-report",
    Component: React.lazy(() => import("../../Pages/Reports/AuditReport")),
    exact: true,
    isNavbar: true
  },
  {
    path: "/reports/audit-report/review",
    Component: React.lazy(
      () => import("../../Pages/Reports/AuditReport/observation")
    ),
    exact: true,
    isNavbar: true
  },
  //milestone checklist
  {
    path: "/crm-master/milestone-checklist",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/MilestoneChecklist")
    ),
    exact: true,
    isNavbar: true
  },

  {
    path: "/crm-master/milestone-checklist/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/MilestoneChecklist/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/milestone-checklist/form",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/MilestoneChecklist/form")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/milestone-checklist/review",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/MilestoneChecklist/ReviewForm")
    ),
    exact: true,
    isNavbar: true
  },
  {
    path: "/crm-master/milestone-checklist/edit",
    Component: React.lazy(
      () => import("../../Pages/Master/CrmMaster/MilestoneChecklist/edit")
    ),
    exact: true,
    isNavbar: true
  }
];
